import { useAppTranslation } from '../i18n/useAppTranslation';
import SportUniverse from '../components/SportUniverse';
import { PerformanceProfile, PerformanceEvolution } from '../components/PerformanceCharts';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { useConfirm } from '../components/ConfirmDialog';
import TrialBanner from '../components/TrialBanner';
import RatingSquares from '../components/RatingSquares';
import DeleteAccountButton from '../components/DeleteAccountButton';
import ChangePassword from '../components/ChangePassword';
import { isNativeApp } from '../utils/platform';
import {
  Container,
  Typography,
  Button,
  Box,
  Paper,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Chip,
  IconButton,
  Divider,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Stack,
  Alert,
  Snackbar,
  useTheme,
  useMediaQuery,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  ToggleButton,
  ToggleButtonGroup,
  Pagination,
  Collapse,
} from '@mui/material';
import {
  Euro,
  ExpandMore,
  ExpandLess,
  Event as EventIcon,
  FitnessCenter,
  CheckCircle,
  Cancel,
  Schedule,
  Add,
  Person,
  ArrowForwardIos,
  History,
  Save,
  School,
  Language,
  Work,
  Payment,
  LocationOn,
  Assessment,
  Email,
  ShowChart,
  Chat,
  CloudUpload,
  Edit,
  Delete,
  Link as LinkIcon,
  ViewModule,
  ViewList,
  CalendarMonth,
} from '@mui/icons-material';
import { getMediaUrl } from '../utils/imageUrl';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import {
  Bar,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import api from '../services/api';
import Sidebar, { SidebarItem, SidebarSubItem } from '../components/Sidebar';
import { format, parseISO } from 'date-fns';

import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  Payment as PaymentIcon2,
  ManageAccounts as ManageAccountsIcon,
  Menu as MenuIcon,
  PersonAdd as PersonAddIcon,
  Close,
} from '@mui/icons-material';
import calendarLocales from '@fullcalendar/core/locales-all';


interface PerformanceFormData {
  endurance: number;
  technical_mastery: number;
  mental_strength: number;
  fatigue_level: number;
  stress_level: number;
  coordination: number;
  motivation: number;
  explosivite: number;
  tactique: number;
  volontaire: number;
  global_score: number;
  notes: string;
  date: string;
}

const CoachDashboard = () => {
  const { tr, locale, dateLocale, language, direction } = useAppTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, refreshUser } = useAuth();
  const toast = useToast();
  const confirm = useConfirm();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [tabValue, setTabValue] = useState(() => {
    try {
      const saved = sessionStorage.getItem('coach_tab');
      const n = saved !== null ? Number(saved) : 0;
      return isNaN(n) ? 0 : n;
    } catch { return 0; }
  });

  useEffect(() => {
    const state = location.state as { tab?: number } | null;
    if (state && state.tab !== undefined) {
      setTabValue(state.tab);
      sessionStorage.setItem('coach_tab', String(state.tab));
    }
  }, [location.state]);

  const [events, setEvents] = useState<any[]>([]);
  const [bookings, setBookings] = useState<any[]>([]);
  const [availabilities, setAvailabilities] = useState<any[]>([]);
  const [payments, setPayments] = useState<any[]>([]);
  const [subscription, setSubscription] = useState<any>(null);
  // Statut d'acces calcule par le backend (exclut admin/demo, applique le delai
  // de grace). Source de verite unique pour l'ecran de blocage d'essai.
  const [accessLocked, setAccessLocked] = useState(false);
  const [programs, setPrograms] = useState<any[]>([]);
  const [sportifs, setSportifs] = useState<any[]>([]);
  const [selectedSportif, setSelectedSportif] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const [listPage, setListPage] = useState(1);
  const [openProgramModal, setOpenProgramModal] = useState(false);
  const [openSportifModal, setOpenSportifModal] = useState(false);
  const [openInviteModal, setOpenInviteModal] = useState(false);
  const [inviteData, setInviteData] = useState({ email: '', name: '', custom_message: '' });
  const [invitations, setInvitations] = useState<any[]>([]);
  const [openInvitationsModal, setOpenInvitationsModal] = useState(false);
  const [bookingFilter, setBookingFilter] = useState('ALL');
  const [openCreateSession, setOpenCreateSession] = useState(false);
  const [newSession, setNewSession] = useState({ sportif_id: '', start_time: '', end_time: '', program_id: '' });
  const [createSessionError, setCreateSessionError] = useState('');
  const [subscriptionRequiredOpen, setSubscriptionRequiredOpen] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [viewModeSportifs, setViewModeSportifs] = useState<'grid' | 'list'>('list');
  const [levelFilter, setLevelFilter] = useState<string | null>(null);
  const [viewModeSeances, setViewModeSeances] = useState<'grid' | 'list'>('list');
  const [viewModeDashboard, setViewModeDashboard] = useState<'grid' | 'list'>('list');
  const [showHistorique, setShowHistorique] = useState(false);
  const [calPopoverAnchor, setCalPopoverAnchor] = useState<HTMLElement | null>(null);
  const [calPopoverEvent, setCalPopoverEvent] = useState<any>(null);
  const [calAvailPopoverAnchor, setCalAvailPopoverAnchor] = useState<HTMLElement | null>(null);
  const [calAvailPopoverEvent, setCalAvailPopoverEvent] = useState<any>(null);
  const [editingAvailId, setEditingAvailId] = useState<number | null>(null);
  const [calDayModal, setCalDayModal] = useState<{ open: boolean; date: string; events: any[] }>({ open: false, date: '', events: [] });
  const [openEditBookingModal, setOpenEditBookingModal] = useState(false);
  const [editingBooking, setEditingBooking] = useState<any>(null);
  const [editBookingTimes, setEditBookingTimes] = useState({ start_time: '', end_time: '' });
  const [confirmAction, setConfirmAction] = useState<{ type: 'pay' | 'cancel' | 'complete' | 'deleteAvail'; bookingId?: number; availId?: number } | null>(null);

  // Performance State
  const [performances, setPerformances] = useState<any[]>([]);
  const [showPerformanceForm, setShowPerformanceForm] = useState(false);
  const [editingPerformanceId, setEditingPerformanceId] = useState<number | null>(null);
  const [perfLinkedBookingId, setPerfLinkedBookingId] = useState<number | ''>('');
  const [sportifModalTab, setSportifModalTab] = useState(0); // 0: Sessions, 1: Performances
  const [newPerformance, setNewPerformance] = useState<PerformanceFormData>({
    endurance: 5,
    technical_mastery: 5,
    mental_strength: 5,
    fatigue_level: 5,
    stress_level: 5,
    coordination: 5,
    motivation: 5,
    explosivite: 5,
    tactique: 5,
    volontaire: 5,
    global_score: 50,
    notes: '',
    date: new Date().toISOString().split('T')[0]
  });
  
  // Profile Form State
  const [profileData, setProfileData] = useState({
    bio: '',
    specialties: '',
    sport: '',
    hourly_rate: '',
    address: '',
    payment_methods: '',
    education: '',
    experience: '',
    languages: '',
    diplomas: '',
    iban: '',
    bic: '',
    city: '',
    postal_code: '',
    department: '',
    training_city: '',
    is_itinerant: 'false',
    social_instagram: '',
    social_linkedin: '',
    social_facebook: '',
    social_website: '',
    social_tiktok: '',
    social_x: '',
    social_snapchat: '',
    social_youtube: '',
    social_pinterest: '',
    social_whatsapp: ''
  });
  const [selectedPhoto, setSelectedPhoto] = useState<File | null>(null);
  const [photoPreview, setPhotoPreview] = useState<string | null>(null);
  const [profileMessage, setProfileMessage] = useState({ type: '', text: '' });

  // Stats
  const [stats, setStats] = useState({
    earnings: 0,
    upcomingSessions: 0,
    totalPrograms: 0
  });

  const [newAvailability, setNewAvailability] = useState({
    start_time: '',
    end_time: '',
    is_recurring: false,
    max_participants: 1
  });
  const [planModalMode, setPlanModalMode] = useState<'availability' | 'session'>('availability');
  const [planSessionData, setPlanSessionData] = useState({ sportif_ids: [] as number[], program_id: '', note: '' });
  const [planModalError, setPlanModalError] = useState('');

  const [newProgram, setNewProgram] = useState({
    title: '',
    description: '',
    price: ''
  });

  // Rating Modal State
  const [openRatingModal, setOpenRatingModal] = useState(false);
  const [currentBookingId, setCurrentBookingId] = useState<number | null>(null);
  const [ratingData, setRatingData] = useState({
    endurance: 5,
    technical_mastery: 5,
    mental_strength: 5,
    fatigue_level: 5,
    stress_level: 5,
    coordination: 5,
    motivation: 5,
    explosivite: 5,
    tactique: 5,
    volontaire: 5,
    global_score: 50,
    notes: ''
  });
  
  const bookingStatusConfig: Record<string, { label: string; color: string; bg: string; dot: string }> = {
    PENDING:   { label: 'En attente',  color: '#D97706', bg: '#FEF3C7', dot: '#F59E0B' },
    CONFIRMED: { label: 'Confirmé',    color: '#1D4ED8', bg: '#DBEAFE', dot: '#3B82F6' },
    COMPLETED: { label: 'Terminé',     color: '#065F46', bg: '#D1FAE5', dot: '#10B981' },
    CANCELLED: { label: 'Annulé',      color: '#991B1B', bg: '#FEE2E2', dot: '#EF4444' },
  };

  const paymentStatusConfig: Record<string, { label: string; color: string; bg: string }> = {
    COMPLETED: { label: 'Payé',         color: '#065F46', bg: '#D1FAE5' },
    PENDING:   { label: 'En attente',   color: '#D97706', bg: '#FEF3C7' },
    FAILED:    { label: 'Échoué',       color: '#991B1B', bg: '#FEE2E2' },
    REFUNDED:  { label: 'Remboursé',    color: '#1D4ED8', bg: '#DBEAFE' },
    UNPAID:    { label: 'Impayé',       color: '#6B7280', bg: '#F3F4F6' },
  };

  const StatusBadge = ({ status, isCoachCreated }: { status: string; isCoachCreated?: boolean }) => {
    const waitingConfirm = isCoachCreated && status === 'PENDING';
    const confirmedBySportif = isCoachCreated && status === 'CONFIRMED';
    const cfg = waitingConfirm
      ? { label: '⏳ En attente de confirmation sportif', color: '#B45309', bg: '#FEF3C7', dot: '#F59E0B' }
      : confirmedBySportif
      ? { label: '✅ Confirmé par le sportif', color: '#065F46', bg: '#D1FAE5', dot: '#22C55E' }
      : (bookingStatusConfig[status] ?? { label: status, color: '#6B7280', bg: '#F3F4F6', dot: '#9CA3AF' });
    return (
      <Box component="span" sx={{
        display: 'inline-flex', alignItems: 'center', gap: 0.6,
        px: 1.2, py: 0.35, borderRadius: '999px',
        bgcolor: cfg.bg, color: cfg.color,
        fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.02em',
        border: `1px solid ${cfg.color}30`,
        whiteSpace: 'nowrap',
      }}>
        <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: cfg.dot, flexShrink: 0 }} />
        {tr(cfg.label)}
      </Box>
    );
  };

  const PaymentBadge = ({ status }: { status: string }) => {
    const cfg = paymentStatusConfig[status ?? 'UNPAID'] ?? { label: status, color: '#6B7280', bg: '#F3F4F6' };
    return (
      <Box component="span" sx={{
        display: 'inline-flex', alignItems: 'center', gap: 0.5,
        px: 1.2, py: 0.35, borderRadius: '999px',
        bgcolor: cfg.bg, color: cfg.color,
        fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.02em',
        border: `1px solid ${cfg.color}30`,
        whiteSpace: 'nowrap',
      }}>
        {status === 'COMPLETED' ? '✓ ' : ''}{tr(cfg.label)}
      </Box>
    );
  };

  useEffect(() => {
    const state = location.state as { tab?: number } | null;
    if (state?.tab !== undefined) {
      setTabValue(state.tab);
      window.history.replaceState({}, '');
    }
  }, [location.state]);

  useEffect(() => {
    // Données critiques immédiatement (onglet 0 = tableau de bord)
    refreshAll();
    // Données secondaires différées après le rendu initial
    const timer = setTimeout(() => {
      fetchPrograms();
      fetchSportifs();
      fetchPayments();
      fetchSubscription();
    }, 300);

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') refreshAll();
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const hasPending = bookings.some(b => b.is_coach_created && b.status === 'PENDING');
    const delay = hasPending ? 5000 : 30000;
    const id = setInterval(() => refreshAll().catch(() => {}), delay);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookings]);

  useEffect(() => {
    if (user?.coach_profile) {
      setProfileData({
        bio: user.coach_profile.bio || '',
        specialties: user.coach_profile.specialties || '',
        sport: user.coach_profile.sport || '',
        hourly_rate: user.coach_profile.hourly_rate || '',
        address: user.coach_profile.address || '',
        payment_methods: user.coach_profile.payment_methods || '',
        education: user.coach_profile.education || '',
        experience: user.coach_profile.experience || '',
        languages: user.coach_profile.languages || '',
        diplomas: user.coach_profile.diplomas || '',
        iban: user.coach_profile.iban || '',
        bic: user.coach_profile.bic || '',
        city: user.coach_profile.city || '',
        postal_code: user.coach_profile.postal_code || '',
        department: user.coach_profile.department || '',
        training_city: user.coach_profile.training_city || '',
        is_itinerant: String(user.coach_profile.is_itinerant ?? false),
        social_instagram: user.coach_profile.social_instagram || '',
        social_linkedin: user.coach_profile.social_linkedin || '',
        social_facebook: user.coach_profile.social_facebook || '',
        social_website: user.coach_profile.social_website || '',
        social_tiktok: user.coach_profile.social_tiktok || '',
        social_x: user.coach_profile.social_x || '',
        social_snapchat: user.coach_profile.social_snapchat || '',
        social_youtube: user.coach_profile.social_youtube || '',
        social_pinterest: user.coach_profile.social_pinterest || '',
        social_whatsapp: user.coach_profile.social_whatsapp || ''
      });
      if (user.coach_profile.photo) {
        setPhotoPreview(getMediaUrl(user.coach_profile.photo) || null);
      }
    }
  }, [user]);

  useEffect(() => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    const earnings = payments
      .filter(p => {
        const d = new Date(p.created_at);
        return p.status === 'COMPLETED'
          && d.getMonth() === currentMonth && d.getFullYear() === currentYear;
      })
      .reduce((acc, curr) => acc + Number(curr.amount || 0), 0);
    const upcomingBookings = bookings.filter(b => (b.status === 'PENDING' || b.status === 'CONFIRMED') && new Date(b.end_time) >= now).length;
    const upcomingSlots = availabilities.filter(av => !av.is_booked && new Date(av.end_time) >= now).length;
    setStats({ earnings, upcomingSessions: upcomingBookings + upcomingSlots, totalPrograms: programs.length });
  }, [bookings, programs, availabilities, payments]);

  const fetchPrograms = async () => {
    try {
      const response = await api.get('/coaching/programs/');
      setPrograms(response.data);
    } catch (error) {
      console.error('Failed to fetch programs', error);
    }
  };

  const fetchSportifs = async () => {
    try {
      const response = await api.get('/coaching/clients/');
      setSportifs(response.data);
    } catch (error: any) {
      console.error('Failed to fetch sportifs', error);
      if (error.response?.status === 401) {
          logout();
      }
    }
  };

  const fetchAvailabilities = async () => {
    try {
      const response = await api.get('/coaching/availabilities/');
      setAvailabilities(response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch availabilities", error);
      return [];
    }
  };

  const fetchBookings = async () => {
    try {
      const response = await api.get('/coaching/bookings/');
      setBookings(response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch bookings", error);
      return [];
    }
  };

  const fetchPayments = async () => {
    try {
      const response = await api.get('/payments/payments/');
      setPayments(response.data);
    } catch (error) {
      console.error("Failed to fetch payments", error);
    }
  };

  const fetchSubscription = async () => {
    try {
        const response = await api.get('/payments/subscriptions/my_subscription/');
        setSubscription(response.data);
    } catch (error) {
        console.error("Failed to fetch subscription", error);
    }
    // Statut d'acces (verrou d'essai) : calcule cote serveur, il tient compte
    // du role (admin jamais verrouille), des comptes demo et du delai de grace.
    try {
        const acc = await api.get('/payments/subscriptions/access_status/');
        setAccessLocked(Boolean(acc.data?.is_locked));
    } catch {
        setAccessLocked(false);
    }
  };

  const refreshAll = async () => {
    const statusColors: Record<string, { bg: string; border: string }> = {
      PENDING:   { bg: '#F59E0B', border: '#D97706' },
      CONFIRMED: { bg: '#3B82F6', border: '#1D4ED8' },
      COMPLETED: { bg: '#22C55E', border: '#065F46' },
      CANCELLED: { bg: '#EF4444', border: '#991B1B' },
    };
    const [avData, bkData] = await Promise.all([fetchAvailabilities(), fetchBookings()]);
    const avEvents = avData.map((av: any) => ({
      id: `av-${av.id}`,
      title: '🟢 Créneau',
      start: av.start_time,
      end: av.end_time,
      backgroundColor: '#10B981',
      borderColor: '#059669',
      textColor: '#ffffff',
      extendedProps: { availability: av }
    }));
    const bkEvents = bkData.map((bk: any) => {
      const colors = statusColors[bk.status] ?? { bg: '#6B7280', border: '#4B5563' };
      return {
        id: `bk-${bk.id}`,
        title: bk.sportif_details?.username || 'Sportif',
        start: bk.start_time,
        end: bk.end_time,
        backgroundColor: colors.bg,
        borderColor: colors.border,
        textColor: '#ffffff',
        extendedProps: { booking: bk }
      };
    });
    setEvents([...avEvents, ...bkEvents]);
    await fetchPrograms();
    await fetchSportifs();
    await fetchPayments();
  };

  const handleCreateProgram = async () => {
    try {
      await api.post('/coaching/programs/', {
        title: newProgram.title,
        description: newProgram.description,
        price: Number(newProgram.price || 0),
      });
      setOpenProgramModal(false);
      setNewProgram({ title: '', description: '', price: '' });
      await fetchPrograms();
    } catch (error) {
      console.error('Failed to create program', error);
    }
  };

  const handleBookingAction = async (bookingId: number, action: 'confirm' | 'complete' | 'cancel') => {
    if (action === 'complete') {
      setCurrentBookingId(bookingId);
      // Pre-fill date with today
      setRatingData({
        endurance: 5,
        technical_mastery: 5,
        mental_strength: 5,
        fatigue_level: 5,
        stress_level: 5,
        coordination: 5,
        motivation: 5,
        explosivite: 5,
        tactique: 5,
        volontaire: 5,
        global_score: 50,
        notes: ''
      });
      setOpenRatingModal(true);
      return;
    }

    try {
      await api.post(`/coaching/bookings/${bookingId}/${action}/`);
      await refreshAll();
    } catch (error) {
      console.error(`Failed to ${action} booking`, error);
    }
  };

  const submitRatingAndComplete = async () => {
    if (!currentBookingId) return;

    try {
      // 1. Complete the booking
      await api.post(`/coaching/bookings/${currentBookingId}/complete/`);
      
      // 2. Create the performance record
      const booking = bookings.find(b => b.id === currentBookingId);
      if (booking) {
        await api.post('/coaching/performances/', {
          ...ratingData,
          date: new Date().toISOString().split('T')[0],
          sportif: booking.sportif, // Send ID
          booking: currentBookingId
        });
      }

      setOpenRatingModal(false);
      setCurrentBookingId(null);
      await refreshAll();
    } catch (error) {
      console.error("Failed to complete booking and save rating", error);
      setProfileMessage({ type: 'error', text: "Erreur lors de l'enregistrement. Veuillez réessayer." });
    }
  };

  const handleDeleteAvailability = async (id: number) => {
    const ok = await confirm({
      title: 'Supprimer cette plage de disponibilité ?',
      description: "Le créneau ne sera plus proposé aux sportifs. Les réservations déjà acceptées ne sont pas annulées.",
      confirmLabel: 'Supprimer la plage',
    });
    if (!ok) return;
    try {
      await api.delete(`/coaching/availabilities/${id}/`);
      setCalAvailPopoverAnchor(null);
      setCalAvailPopoverEvent(null);
      await refreshAll();
    } catch (e) {
      console.error('Failed to delete availability', e);
    }
  };

  const handleSaveAvailability = async () => {
    try {
      if (editingAvailId) {
        await api.patch(`/coaching/availabilities/${editingAvailId}/`, {
          start_time: newAvailability.start_time,
          end_time:   newAvailability.end_time,
          is_recurring: newAvailability.is_recurring,
          max_participants: newAvailability.max_participants,
        });
        setEditingAvailId(null);
      } else {
        await api.post('/coaching/availabilities/', {
          start_time: newAvailability.start_time,
          end_time:   newAvailability.end_time,
          is_recurring: newAvailability.is_recurring,
          max_participants: newAvailability.max_participants,
        });
      }
      setOpenModal(false);
      await refreshAll();
    } catch (e) {
      console.error('Failed to save availability', e);
    }
  };

  const handleCreateSession = async () => {
    if (planSessionData.sportif_ids.length === 0) return;
    setPlanModalError('');
    try {
      await Promise.all(planSessionData.sportif_ids.map(sportifId =>
        api.post('/coaching/sessions/create/', {
          sportif: sportifId,
          start_time: newAvailability.start_time,
          end_time:   newAvailability.end_time,
          ...(planSessionData.program_id ? { program: planSessionData.program_id } : {}),
        })
      ));
      setOpenModal(false);
      setPlanSessionData({ sportif_ids: [], program_id: '', note: '' });
      setPlanModalError('');
      await refreshAll();
    } catch (e: any) {
      if (e?.response?.data?.subscription_required) {
        setOpenModal(false);
        setSubscriptionRequiredOpen(true);
        return;
      }
      const msg = e?.response?.data?.detail ||
        (typeof e?.response?.data === 'string' ? e.response.data : null) ||
        'Erreur lors de la création de la séance.';
      setPlanModalError(msg);
      console.error('Failed to create session', e?.response?.data || e);
    }
  };

  const handleSaveEditBooking = async () => {
    if (!editingBooking) return;
    try {
      await api.patch(`/coaching/bookings/${editingBooking.id}/`, {
        start_time: editBookingTimes.start_time,
        end_time:   editBookingTimes.end_time,
      });
      setOpenEditBookingModal(false);
      setEditingBooking(null);
      await refreshAll();
    } catch (e) {
      console.error('Failed to update booking', e);
    }
  };

  const handleMarkPaid = async (bookingId: number) => {
    try {
      await api.post('/payments/payments/checkout/', { booking_id: bookingId });
      await refreshAll();
    } catch (e: any) {
      console.error('[handleMarkPaid] error:', e?.response?.status, e?.response?.data || e?.message);
    }
  };

  const handleViewSportif = async (sportif: any) => {
    setSelectedSportif(sportif);
    setOpenSportifModal(true);
    setSportifModalTab(0); // Reset to first tab
    try {
      const res = await api.get(`/coaching/performances/?sportif_id=${sportif.id}`);
      setPerformances(res.data);
    } catch (err) {
      console.error("Error fetching performances", err);
    }
  };

  const selectSportifAndGoTo = async (sportif: any, tab: number) => {
    setSelectedSportif(sportif);
    setShowPerformanceForm(false);
    try {
      const res = await api.get(`/coaching/performances/?sportif_id=${sportif.id}`);
      setPerformances(res.data);
    } catch (err) {
      console.error("Error fetching performances", err);
    }
    setTabValue(tab);
  };

  const selectSportifById = async (id: number) => {
    const sportif = sportifs.find((s) => s.id === id);
    if (!sportif) return;
    setSelectedSportif(sportif);
    setShowPerformanceForm(false);
    try {
      const res = await api.get(`/coaching/performances/?sportif_id=${sportif.id}`);
      setPerformances(res.data);
    } catch (err) {
      console.error("Error fetching performances", err);
    }
  };

  // Auto-sélectionner le premier sportif quand on entre dans Performances sans sélection
  useEffect(() => {
    if (tabValue === 3 && !selectedSportif && sportifs.length > 0) {
      selectSportifById(sportifs[0].id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue, sportifs]);

  const fetchInvitations = async () => {
    try {
        const response = await api.get('/coaching/invitations/');
        setInvitations(response.data);
    } catch (error) {
        console.error("Failed to fetch invitations", error);
    }
  };


  const handleSendInvite = async () => {
    try {
        await api.post('/coaching/invite/', { ...inviteData, mode: 'email' });
        setOpenInviteModal(false);
        setInviteData({ email: '', name: '', custom_message: '' });
        setProfileMessage({ type: 'success', text: 'Invitation envoyée avec succès !' });
        // Refresh invitations list if open
        fetchInvitations();
    } catch (error: any) {
        console.error("Error sending invitation", error);
        const msg = error?.response?.data?.error || error?.response?.data?.detail || "Erreur lors de l'envoi de l'invitation.";
        setProfileMessage({ type: 'error', text: msg });
    }
  };

  const resetPerfForm = () => {
    setNewPerformance({
      endurance: 5, technical_mastery: 5, mental_strength: 5,
      fatigue_level: 5, stress_level: 5, coordination: 5, motivation: 5,
      explosivite: 5, tactique: 5, volontaire: 5, global_score: 50,
      notes: '', date: new Date().toISOString().split('T')[0]
    });
    setEditingPerformanceId(null);
    setPerfLinkedBookingId('');
    setShowPerformanceForm(false);
  };

  const handleSavePerformance = async () => {
    if (!selectedSportif) return;
    try {
      const payload = {
        sportif: selectedSportif.id,
        date: newPerformance.date,
        endurance: newPerformance.endurance,
        technical_mastery: newPerformance.technical_mastery,
        mental_strength: newPerformance.mental_strength,
        fatigue_level: newPerformance.fatigue_level,
        stress_level: newPerformance.stress_level,
        coordination: newPerformance.coordination,
        motivation: newPerformance.motivation,
        explosivite: newPerformance.explosivite,
        tactique: newPerformance.tactique,
        volontaire: newPerformance.volontaire,
        global_score: newPerformance.global_score,
        notes: newPerformance.notes,
        ...(perfLinkedBookingId ? { booking: perfLinkedBookingId } : {}),
      };
      if (editingPerformanceId) {
        await api.patch(`/coaching/performances/${editingPerformanceId}/`, payload);
      } else {
        await api.post('/coaching/performances/', payload);
      }
      const res = await api.get(`/coaching/performances/?sportif_id=${selectedSportif.id}`);
      setPerformances(res.data);
      resetPerfForm();
      setProfileMessage({ type: 'success', text: editingPerformanceId ? 'Évaluation modifiée !' : 'Évaluation enregistrée !' });
    } catch (error: any) {
      console.error("Error saving performance", error?.response?.data || error);
      setProfileMessage({ type: 'error', text: "Erreur lors de l'enregistrement." });
    }
  };

  const handleCreatePerformance = handleSavePerformance;

  const handleEditPerformance = (perf: any) => {
    setNewPerformance({
      endurance: perf.endurance ?? 5, technical_mastery: perf.technical_mastery,
      mental_strength: perf.mental_strength, fatigue_level: perf.fatigue_level,
      stress_level: perf.stress_level, coordination: perf.coordination ?? 5,
      motivation: perf.motivation, explosivite: perf.explosivite ?? 5,
      tactique: perf.tactique ?? 5, volontaire: perf.volontaire ?? 5,
      global_score: perf.global_score, notes: perf.notes ?? '', date: perf.date,
    });
    setEditingPerformanceId(perf.id);
    setPerfLinkedBookingId(perf.booking ?? '');
    setShowPerformanceForm(true);
  };

  const handleDeletePerformance = async (perfId: number) => {
    if (!selectedSportif) return;
    const ok = await confirm({
      title: 'Supprimer cette évaluation ?',
      description: "Les notes de cette séance seront définitivement perdues et la courbe de progression sera recalculée.",
      confirmLabel: "Supprimer l'évaluation",
    });
    if (!ok) return;
    try {
      await api.delete(`/coaching/performances/${perfId}/`);
      const res = await api.get(`/coaching/performances/?sportif_id=${selectedSportif.id}`);
      setPerformances(res.data);
      setProfileMessage({ type: 'success', text: 'Évaluation supprimée.' });
    } catch (error) {
      console.error("Error deleting performance", error);
      setProfileMessage({ type: 'error', text: "Erreur lors de la suppression." });
    }
  };


  const handlePhotoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedPhoto(file);
      // For immediate local preview before upload
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  const handleProfileUpdate = async () => {
    try {
      const formData = new FormData();
      Object.keys(profileData).forEach(key => {
        const value = profileData[key as keyof typeof profileData];
        formData.append(key, String(value));
      });
      
      if (selectedPhoto) {
        formData.append('photo', selectedPhoto);
      }

      await api.patch('/users/me/coach_profile/', formData);
      setProfileMessage({ type: 'success', text: 'Profil mis à jour avec succès !' });
      await refreshUser();
    } catch (error) {
      console.error('Update profile failed', error);
      setProfileMessage({ type: 'error', text: 'Erreur lors de la mise à jour du profil.' });
    }
  };

  // Prepare chart data with safe defaults
  const chartData = [...performances]
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
    .map(p => {
      // Debug log for each performance to verify data
      return {
        date: p.date,
        endurance: p.endurance || 0,
        technical_mastery: p.technical_mastery || 0,
        mental_strength: p.mental_strength || 0,
        motivation: p.motivation || 0,
        fatigue_level: p.fatigue_level || 0,
        stress_level: p.stress_level || 0,
        coordination: p.coordination || 0,
        explosivite: p.explosivite || 0,
        tactique: p.tactique || 0,
        volontaire: p.volontaire || 0,
        global_score: (p.global_score || 0) / 10
      };
    });

  // Prepare radar data from the latest performance (last item in sorted chartData)
  const latestPerformance = chartData.length > 0 ? chartData[chartData.length - 1] : null;

  const radarData = latestPerformance ? [
    { subject: 'Endurance', A: latestPerformance.endurance, fullMark: 10 },
    { subject: 'Technique', A: latestPerformance.technical_mastery, fullMark: 10 },
    { subject: 'Mental', A: latestPerformance.mental_strength, fullMark: 10 },
    { subject: 'En forme', A: latestPerformance.fatigue_level, fullMark: 10 },
    { subject: 'Gestion Émotion', A: latestPerformance.stress_level, fullMark: 10 },
    { subject: 'Coordination', A: latestPerformance.coordination, fullMark: 10 },
    { subject: 'Motivation', A: latestPerformance.motivation, fullMark: 10 },
    { subject: 'Explosivité', A: latestPerformance.explosivite, fullMark: 10 },
    { subject: 'Tactique', A: latestPerformance.tactique, fullMark: 10 },
    { subject: 'Volonté', A: latestPerformance.volontaire, fullMark: 10 },
  ] : [];

  const sidebarItems: SidebarItem[] = [
    { label: 'Tableau de bord', icon: <DashboardIcon fontSize="small" />, index: 0 },
    { label: 'Séances', icon: <History fontSize="small" />, index: 2 },
    { label: `${tr("Sportifs")} (${sportifs.length})`, icon: <GroupIcon fontSize="small" />, index: 1 },
    { label: 'Performances', icon: <Assessment fontSize="small" />, index: 3 },
    { label: 'Invitations', icon: <PersonAddIcon fontSize="small" />, index: 4 },
    { label: 'Messages', icon: <Chat fontSize="small" />, index: -1, navigateTo: '/messages', navigateState: { roleMode: 'COACH' } },
    { label: 'Paiements', icon: <PaymentIcon2 fontSize="small" />, index: 5 },
    { label: 'Mon Profil', icon: <ManageAccountsIcon fontSize="small" />, index: 6 },
  ];

  return (
    <Box sx={{ display: 'flex', bgcolor: 'background.default', minHeight: '100vh' }}>
      <Sidebar
        items={sidebarItems}
        activeIndex={tabValue}
        onSelect={(idx) => { setTabValue(idx); sessionStorage.setItem('coach_tab', String(idx)); }}
        user={user}
        onLogout={logout}
        role="COACH"
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />
      <Box sx={{ flexGrow: 1, overflow: 'auto', minWidth: 0 }}>
        {/* Mobile header */}
        {isMobile && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200, paddingTop: 'max(12px, env(safe-area-inset-top))' }}>
            <IconButton aria-label={tr("Ouvrir le menu")} size="small" onClick={() => setMobileSidebarOpen(true)}>
              <MenuIcon />
            </IconButton>
            <Box component="img" src="/g1s-logo-3d.png" sx={{ height: 32 }} />
            <Typography variant="h6" sx={{ fontWeight: 900, color: '#FFD700' }}>G1Sport</Typography>
          </Box>
        )}
      <Container maxWidth="xl" sx={{ mt: isMobile ? 'calc(64px + env(safe-area-inset-top))' : 4, mb: 4, px: isMobile ? 1 : 3 }}>
        <SportUniverse sport={profileData.sport} compact />
        <TrialBanner />
        {tabValue !== 5 && (
        <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', mb: 4, gap: 1 }}>
          <Box>
            <Typography variant={isMobile ? "h5" : "h4"} component="h1" sx={{ fontWeight: 800, color: 'text.primary' }}>
              {sidebarItems.find(i => i.index === tabValue)?.label.split('(')[0].trim()}
            </Typography>
            <Typography variant="body2" color="text.secondary">{tr("Bon retour,")} {user?.username}</Typography>
          </Box>
        </Box>
        )}
      
        {/* TabPanel 0: Tableau de bord */}
        {tabValue === 0 && (
          <>
            {/* Stats Cards */}
            <Grid container spacing={isMobile ? 2 : 3} sx={{ mb: 4 }}>
              {[
                { emoji: '💶', value: `${stats.earnings} €`, label: tr("Revenus du mois"), color: '#6366F1' },
                { emoji: '✅', value: bookings.filter(b => b.status === 'COMPLETED').length, label: tr("Séances réalisées"), color: '#22C55E' },
                { emoji: '🟢', value: (() => { const n = new Date(); return availabilities.filter(av => !av.is_booked && new Date(av.end_time) >= n).length; })(), label: tr("Créneaux disponibles"), color: '#10B981' },
                { emoji: '📅', value: (() => { const n = new Date(); return bookings.filter(b => b.is_coach_created && (b.status === 'CONFIRMED' || b.status === 'PENDING') && new Date(b.end_time) >= n).length; })(), label: tr("Séances directes"), color: '#3B82F6' },
                { emoji: '👤', value: sportifs.length, label: 'Sportifs actifs', color: '#8B5CF6' },
                { emoji: '🏋️', value: stats.totalPrograms, label: tr("Programmes actifs"), color: '#F59E0B' },
              ].map(({ emoji, value, label, color }) => (
                <Grid key={tr(label)} size={{ xs: 6, sm: 4, md: 2 }} sx={{ display: 'flex' }}>
                  <Box sx={{ p: '2px', borderRadius: '20px', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', width: '100%', transition: 'all 0.15s', '&:hover': { boxShadow: `0 6px 28px ${color}55`, transform: 'translateY(-2px)' } }}>
                    <Box sx={{ p: 2, borderRadius: '18px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.3, height: '100%', bgcolor: 'background.paper' }}>
                      <Typography sx={{ fontSize: 24, lineHeight: 1, mb: 0.3 }}>{emoji}</Typography>
                      <Typography variant="h5" fontWeight={900} sx={{ color, lineHeight: 1.1, textShadow: 'none' }}>{value}</Typography>
                      <Typography variant="caption" sx={{ color: '#9CA3AF', lineHeight: 1.2, fontSize: '0.7rem' }}>{tr(label)}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

            <Grid container spacing={3}>
              {/* Left Column: Session List */}
              <Grid size={{ xs: 12, lg: 8 }}>
                <Box>
                  {/* Header */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Box>
                      <Typography variant="h6" fontWeight={800}>{tr("Séances actives")}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {bookings.filter(b => (b.status === 'PENDING' || b.status === 'CONFIRMED') && new Date(b.end_time) >= new Date()).length + availabilities.filter(av => !av.is_booked && new Date(av.end_time) >= new Date()).length}  {tr("élément(s) à venir")} </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <ToggleButtonGroup value={viewModeDashboard} exclusive onChange={(_, v) => v && setViewModeDashboard(v)} size="small">
                        <ToggleButton value="grid" title={tr("Vue grille")}><ViewModule fontSize="small" /></ToggleButton>
                        <ToggleButton value="list" title={tr("Vue liste")}><ViewList fontSize="small" /></ToggleButton>
                      </ToggleButtonGroup>
                      <Button
                        variant="contained"
                        startIcon={<Add />}
                        size="small"
                        onClick={() => {
                          const now = new Date();
                          const plus1h = new Date(now.getTime() + 60 * 60 * 1000);
                          setNewAvailability({
                            start_time: now.toISOString().slice(0, 16),
                            end_time: plus1h.toISOString().slice(0, 16),
                            is_recurring: false,
                            max_participants: 1,
                          });
                          if (accessLocked) {
                            setSubscriptionRequiredOpen(true);
                            return;
                          }
                          setPlanSessionData({ sportif_ids: [], program_id: '', note: '' });
                          setPlanModalError('');
                          setEditingAvailId(null);
                          setPlanModalMode('session');
                          setOpenModal(true);
                        }}
                        sx={{ fontWeight: 700, borderRadius: 2 }}
                      >
                         {tr("Nouvelle séance")} </Button>
                    </Box>
                  </Box>

                  {/* Légende */}
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2, alignItems: 'center' }}>
                    {[
                      { label: tr("En attente"), color: '#F59E0B' },
                      { label: tr("Confirmé"),   color: '#3B82F6' },
                    ].map(({ label, color }) => (
                      <Box key={tr(label)} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color }} />
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>{tr(label)}</Typography>
                      </Box>
                    ))}
                    <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
                      <Chip label={tr("📅 Séance directe")} size="small" sx={{ fontSize: '0.65rem', height: 20, bgcolor: '#3B82F622', color: '#3B82F6', border: '1px solid #3B82F655' }} />
                      <Chip label={tr("🟢 Créneau réservé")} size="small" sx={{ fontSize: '0.65rem', height: 20, bgcolor: '#10B98122', color: '#10B981', border: '1px solid #10B98155' }} />
                    </Box>
                  </Box>

                  {/* Liste — uniquement séances à venir */}
                  <Box>
                    {(() => {
                      const now = new Date();
                      const PAGE_SIZE = 5;

                      // Bookings actifs futurs
                      const upcomingBookings = bookings
                        .filter(b => (b.status === 'PENDING' || b.status === 'CONFIRMED') && new Date(b.end_time) >= now)
                        .map(b => ({ ...b, _type: 'booking' }));

                      // Créneaux disponibles futurs (places restantes > 0)
                      const upcomingSlots = availabilities
                        .filter(av => !av.is_booked && new Date(av.end_time) >= now)
                        .map(av => ({ ...av, _type: 'availability', placesRestantes: av.max_participants - (av.booking_count ?? 0) }));

                      // Fusion triée par date
                      const allItems = [...upcomingBookings, ...upcomingSlots]
                        .sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());

                      const totalPages = Math.max(1, Math.ceil(allItems.length / PAGE_SIZE));

                      if (allItems.length === 0) {
                        return (
                          <Box sx={{ p: 6, textAlign: 'center' }}>
                            <EventIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                            <Typography color="text.secondary" gutterBottom>{tr("Aucune séance à venir")}</Typography>
                            <Button variant="outlined" size="small" startIcon={<Add />}
                              onClick={() => {
                                const n = new Date();
                                const plus1h = new Date(n.getTime() + 60 * 60 * 1000);
                                setNewAvailability({ start_time: n.toISOString().slice(0, 16), end_time: plus1h.toISOString().slice(0, 16), is_recurring: false, max_participants: 1 });
                                setPlanSessionData({ sportif_ids: [], program_id: '', note: '' });
                                setPlanModalError('');
                                setEditingAvailId(null);
                                setPlanModalMode('session');
                                setOpenModal(true);
                              }}>
                               {tr("Planifier une séance")} </Button>
                          </Box>
                        );
                      }

                      // ── VUE GRILLE ──
                      if (viewModeDashboard === 'grid') {
                        return (
                          <Grid container spacing={2}>
                            {allItems.map((item) => {
                              if (item._type === 'availability') {
                                return (
                                  <Grid size={{ xs: 12, sm: 6, md: 4 }} key={`av-${item.id}`}>
                                    <Card variant="outlined" sx={{ borderRadius: 3, borderTop: '3px solid #10B981', transition: 'box-shadow 0.2s', '&:hover': { boxShadow: 3 } }}>
                                      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                          <Typography variant="subtitle2" fontWeight={800}>{tr("Créneau disponible")}</Typography>
                                          <Chip label="🟢" size="small" sx={{ bgcolor: '#10B98122', color: '#10B981', border: '1px solid #10B98155' }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                                          {item.placesRestantes ?? item.max_participants} / {item.max_participants}  {tr("place(s)")} </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary', mb: 0.5 }}>
                                          <Schedule sx={{ fontSize: 13 }} />
                                          <Typography variant="caption">{format(parseISO(item.start_time), 'dd MMM yyyy HH:mm', { locale: dateLocale })}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', gap: 0.5, mt: 1 }}>
                                          <IconButton aria-label={tr("Modifier")} size="small" sx={{ color: '#3B82F6' }} onClick={() => { setEditingAvailId(item.id); setNewAvailability({ start_time: format(parseISO(item.start_time), "yyyy-MM-dd'T'HH:mm"), end_time: format(parseISO(item.end_time), "yyyy-MM-dd'T'HH:mm"), is_recurring: item.is_recurring || false, max_participants: item.max_participants || 1 }); setPlanModalMode('availability'); setPlanModalError(''); setOpenModal(true); }}><Edit sx={{ fontSize: 15 }} /></IconButton>
                                          <IconButton aria-label={tr("Supprimer")} size="small" sx={{ color: '#EF4444' }} onClick={() => handleDeleteAvailability(item.id)}><Delete sx={{ fontSize: 15 }} /></IconButton>
                                        </Box>
                                      </CardContent>
                                    </Card>
                                  </Grid>
                                );
                              }
                              const bk = item;
                              const dotColor = bookingStatusConfig[bk.status]?.dot ?? '#9CA3AF';
                              return (
                                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={`bk-${bk.id}`}>
                                  <Card variant="outlined" sx={{ borderRadius: 3, borderTop: `3px solid ${dotColor}`, transition: 'box-shadow 0.2s', '&:hover': { boxShadow: 3 } }}>
                                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                        <Box>
                                          <Typography variant="subtitle2" fontWeight={800}>{bk.sportif_details?.username}</Typography>
                                          <Typography variant="caption" color="text.secondary">{bk.program_details?.title || tr("Séance libre")}</Typography>
                                        </Box>
                                        <StatusBadge status={bk.status} isCoachCreated={bk.is_coach_created} />
                                      </Box>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary', mb: 0.5 }}>
                                        <Schedule sx={{ fontSize: 13 }} />
                                        <Typography variant="caption">{format(parseISO(bk.start_time), 'dd MMM yyyy HH:mm', { locale: dateLocale })}</Typography>
                                      </Box>
                                      <Box sx={{ mb: 1 }}><PaymentBadge status={bk.latest_payment_status || 'UNPAID'} /></Box>
                                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                        {(bk.status === 'CONFIRMED' || bk.status === 'COMPLETED') && bk.latest_payment_status !== 'COMPLETED' && (
                                          <IconButton aria-label={tr("Marquer comme payé")} size="small" onClick={() => setConfirmAction({ type: 'pay', bookingId: bk.id })} title={tr("Marquer payé")} sx={{ bgcolor: '#16A34A', color: 'white', borderRadius: '50%', width: 28, height: 28, '&:hover': { bgcolor: '#15803D' } }}><Euro sx={{ fontSize: 14 }} /></IconButton>
                                        )}
                                        <IconButton aria-label={tr("Ouvrir la conversation")} size="small" color="primary" onClick={() => navigate('/messages', { state: { recipient: bk.sportif_details, roleMode: 'COACH' } })}><Chat sx={{ fontSize: 14 }} /></IconButton>
                                        {bk.status === 'PENDING' && (<>
                                          <IconButton aria-label="Valider" size="small" color="success" onClick={() => handleBookingAction(bk.id, 'confirm')}><CheckCircle sx={{ fontSize: 14 }} /></IconButton>
                                          <IconButton aria-label={tr("Annuler")} size="small" color="error" onClick={() => setConfirmAction({ type: 'cancel', bookingId: bk.id })}><Cancel sx={{ fontSize: 14 }} /></IconButton>
                                        </>)}
                                        {bk.status === 'CONFIRMED' && (
                                          <IconButton aria-label="Valider" size="small" onClick={() => setConfirmAction({ type: 'complete', bookingId: bk.id })} sx={{ color: 'warning.main' }}><CheckCircle sx={{ fontSize: 14 }} /></IconButton>
                                        )}
                                      </Box>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              );
                            })}
                          </Grid>
                        );
                      }

                      const pagedItems = allItems.slice((listPage - 1) * PAGE_SIZE, listPage * PAGE_SIZE);
                      return (
                        <>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          {pagedItems.map((item) => {

                            // ── Créneau disponible ──
                            if (item._type === 'availability') {
                              return (
                                <Paper key={`av-${item.id}`} variant="outlined" sx={{ borderRadius: 2, borderLeft: '3px solid #10B981', overflow: 'hidden', '&:hover': { boxShadow: 2 } }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 1, flexWrap: 'wrap' }}>
                                    <Box sx={{ minWidth: 0, flex: '1 1 110px' }}>
                                      <Typography variant="body2" fontWeight={800} noWrap>{tr("Créneau libre")}</Typography>
                                      <Typography variant="caption" color="text.secondary" noWrap>{item.placesRestantes ?? item.max_participants}/{item.max_participants}  {tr("place(s)")}</Typography>
                                    </Box>
                                    <Box sx={{ flex: '1 1 120px', minWidth: 0, display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                                      <Schedule sx={{ fontSize: 12, flexShrink: 0 }} />
                                      <Typography variant="caption" noWrap>{format(parseISO(item.start_time), 'dd MMM yy HH:mm', { locale: dateLocale })}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
                                      <IconButton aria-label={tr("Modifier")} size="small" title={tr("Modifier")} sx={{ p: 0.5, bgcolor: '#3B82F622', color: '#3B82F6', borderRadius: '50%', width: 26, height: 26 }}
                                        onClick={() => { setEditingAvailId(item.id); setNewAvailability({ start_time: format(parseISO(item.start_time), "yyyy-MM-dd'T'HH:mm"), end_time: format(parseISO(item.end_time), "yyyy-MM-dd'T'HH:mm"), is_recurring: item.is_recurring || false, max_participants: item.max_participants || 1 }); setPlanModalMode('availability'); setPlanModalError(''); setOpenModal(true); }}>
                                        <Edit sx={{ fontSize: 13 }} />
                                      </IconButton>
                                      <IconButton aria-label={tr("Supprimer")} size="small" title={tr("Supprimer")} sx={{ p: 0.5, bgcolor: '#EF444422', color: '#EF4444', borderRadius: '50%', width: 26, height: 26 }} onClick={() => setConfirmAction({ type: 'deleteAvail', availId: item.id })}>
                                        <Delete sx={{ fontSize: 13 }} />
                                      </IconButton>
                                    </Box>
                                  </Box>
                                </Paper>
                              );
                            }

                            // ── Booking ──
                            const bk = item;
                            const dotColor = bookingStatusConfig[bk.status]?.dot ?? '#9CA3AF';
                            return (
                              <Paper key={`bk-${bk.id}`} variant="outlined" sx={{ borderRadius: 2, borderLeft: `3px solid ${dotColor}`, overflow: 'hidden', '&:hover': { boxShadow: 2 } }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 1, flexWrap: 'wrap' }}>
                                  <Box sx={{ minWidth: 0, flex: '1 1 110px' }}>
                                    <Typography variant="body2" fontWeight={800} noWrap>{bk.sportif_details?.username || '—'}</Typography>
                                    <Typography variant="caption" color="text.secondary" noWrap>{bk.program_details?.title || tr("Séance libre")}</Typography>
                                  </Box>
                                  <Box sx={{ flex: '1 1 120px', minWidth: 0, display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                                    <Schedule sx={{ fontSize: 12, flexShrink: 0 }} />
                                    <Typography variant="caption" noWrap>{format(parseISO(bk.start_time), 'dd MMM yy HH:mm', { locale: dateLocale })}</Typography>
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0, flexWrap: 'wrap' }}>
                                    <PaymentBadge status={bk.latest_payment_status || 'UNPAID'} />
                                    <StatusBadge status={bk.status} isCoachCreated={bk.is_coach_created} />
                                    {(bk.status === 'CONFIRMED' || bk.status === 'COMPLETED') && bk.latest_payment_status !== 'COMPLETED' && (
                                      <IconButton aria-label={tr("Marquer comme payé")} size="small" onClick={() => setConfirmAction({ type: 'pay', bookingId: bk.id })} title={tr("Marquer payé")} sx={{ p: 0.5, bgcolor: '#16A34A', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: '#15803D' } }}>
                                        <Euro sx={{ fontSize: 13 }} />
                                      </IconButton>
                                    )}
                                    <IconButton aria-label={tr("Ouvrir la conversation")} size="small" onClick={() => navigate('/messages', { state: { recipient: bk.sportif_details, roleMode: 'COACH' } })} sx={{ p: 0.5, bgcolor: 'primary.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'primary.dark' } }}>
                                      <Chat sx={{ fontSize: 13 }} />
                                    </IconButton>
                                    {bk.status === 'PENDING' && (
                                      <IconButton aria-label="Valider" size="small" onClick={() => handleBookingAction(bk.id, 'confirm')} title="Accepter" sx={{ p: 0.5, bgcolor: 'success.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'success.dark' } }}>
                                        <CheckCircle sx={{ fontSize: 13 }} />
                                      </IconButton>
                                    )}
                                    {bk.status === 'PENDING' && (
                                      <IconButton aria-label={tr("Annuler")} size="small" onClick={() => setConfirmAction({ type: 'cancel', bookingId: bk.id })} title={tr("Annuler")} sx={{ p: 0.5, bgcolor: 'error.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'error.dark' } }}>
                                        <Cancel sx={{ fontSize: 13 }} />
                                      </IconButton>
                                    )}
                                    {bk.status === 'CONFIRMED' && (
                                      <IconButton aria-label="Valider" size="small" onClick={() => setConfirmAction({ type: 'complete', bookingId: bk.id })} title="Terminer" sx={{ p: 0.5, bgcolor: '#F59E0B', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: '#D97706' } }}>
                                        <CheckCircle sx={{ fontSize: 13 }} />
                                      </IconButton>
                                    )}
                                  </Box>
                                </Box>
                              </Paper>
                            );
                          })}
                        </Box>
                        {totalPages > 1 && (
                          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
                            <Pagination count={totalPages} page={listPage} onChange={(_, p) => setListPage(p)} size="small" color="primary" />
                          </Box>
                        )}
                        </>
                      );
                    })()}
                  </Box>
                </Box>
              </Grid>

              {/* Right Column: Mini Calendar + Programs */}
              <Grid size={{ xs: 12, lg: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

                  {/* Mini Calendar */}
                  <Paper sx={{
                    p: 2, borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                    bgcolor: '#1A1A2E', color: '#fff',
                    '& .fc': {
                      '--fc-page-bg-color': 'transparent',
                      '--fc-border-color': '#2a2a4a',
                      '--fc-today-bg-color': 'rgba(0,143,76,0.15)',
                      fontFamily: 'inherit',
                    },
                    '& .fc-col-header-cell-cushion': { color: '#aaa', fontWeight: 600, fontSize: '0.72rem', textTransform: 'capitalize' },
                    '& .fc-daygrid-day-number': { color: '#ccc', fontSize: '0.78rem', padding: '2px 4px' },
                    '& .fc-toolbar-title': { color: '#fff', fontSize: '0.95rem', fontWeight: 700 },
                    '& .fc-button': {
                      background: '#2a2a4a !important', borderColor: '#3a3a5a !important',
                      color: '#fff !important', padding: '2px 8px !important', fontSize: '0.75rem !important'
                    },
                    '& .fc-theme-standard td, & .fc-theme-standard th': { borderColor: '#2a2a4a' },
                    '& .fc-daygrid-day-top': { justifyContent: 'center' },
                    '& .fc-event': { fontSize: '0.6rem', borderRadius: '3px', border: 'none' },
                    '& .fc-daygrid-event-dot': { display: 'none' },
                    '& .fc-toolbar.fc-header-toolbar': { marginBottom: '8px' },
                  }}>
                    <FullCalendar
                      plugins={[dayGridPlugin, interactionPlugin]}
                      headerToolbar={{ left: 'prev', center: 'title', right: 'next' }}
                      locales={calendarLocales}
                      locale={language === 'zh' ? 'zh-cn' : language}
                      direction={direction}
                      initialView="dayGridMonth"
                      editable={false}
                      selectable={true}
                      events={events}
                      height={280}
                      dayMaxEvents={2}
                      fixedWeekCount={false}
                      showNonCurrentDates={false}
                      dateClick={(info) => {
                        const clickedDate = info.dateStr; // 'YYYY-MM-DD'
                        const dayEvents = events.filter(ev => {
                          const evDate = ev.start ? ev.start.substring(0, 10) : '';
                          return evDate === clickedDate;
                        });
                        setCalDayModal({ open: true, date: clickedDate, events: dayEvents });
                      }}
                      eventClick={(info) => {
                        const evDate = info.event.startStr.substring(0, 10);
                        const dayEvents = events.filter(ev => {
                          const d = ev.start ? ev.start.substring(0, 10) : '';
                          return d === evDate;
                        });
                        setCalDayModal({ open: true, date: evDate, events: dayEvents });
                      }}
                      eventContent={(arg) => {
                        const color = arg.event.backgroundColor || '#3B82F6';
                        return (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, px: 0.5, overflow: 'hidden', cursor: 'pointer' }}>
                            <Box sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
                            <Typography sx={{ fontSize: '0.58rem', color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {arg.event.extendedProps.availability ? tr('🟢 Créneau') : arg.event.title}
                            </Typography>
                          </Box>
                        );
                      }}
                    />
                  </Paper>

                  {/* Programs */}
                  <Paper sx={{ p: 2.5, borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography variant="subtitle1" fontWeight={800}>{tr("Mes Programmes")}</Typography>
                      <IconButton aria-label={tr("Ajouter")} color="primary" onClick={() => setOpenProgramModal(true)} size="small">
                        <Add />
                      </IconButton>
                    </Box>
                    {programs.length === 0 ? (
                      <Box sx={{ p: 3, textAlign: 'center', bgcolor: 'action.hover', borderRadius: 2, border: '1px dashed', borderColor: 'divider' }}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>{tr("Aucun programme")}</Typography>
                        <Button variant="outlined" size="small" onClick={() => setOpenProgramModal(true)}>{tr("Créer")}</Button>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, maxHeight: 240, overflowY: 'auto' }}>
                        {programs.map((p) => (
                          <Box key={p.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1.5, borderRadius: 2, border: '1px solid', borderColor: 'divider', '&:hover': { bgcolor: 'action.hover' } }}>
                            <Box sx={{ minWidth: 0 }}>
                              <Typography variant="body2" fontWeight={700} noWrap>{p.title}</Typography>
                              <Typography variant="caption" color="text.secondary" noWrap>
                                {p.description?.substring(0, 40)}{(p.description?.length || 0) > 40 ? '…' : ''}
                              </Typography>
                            </Box>
                            <Chip label={`${p.price} €`} size="small" color="primary" variant="outlined" sx={{ ml: 1, flexShrink: 0 }} />
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Paper>
                </Box>
              </Grid>
            </Grid>
          </>
        )}

        {/* TabPanel 1: Sportifs */}
        {tabValue === 1 && (
              <>
                {/* KPIs Sportifs */}
                <Grid container spacing={isMobile ? 1.5 : 2} sx={{ mb: 3 }}>
                  {[
                    { emoji: '👥', value: sportifs.length, label: 'Sportifs actifs', color: '#6366F1' },
                    { emoji: '📅', value: sportifs.filter(s => s.next_booking).length, label: tr("Avec séance à venir"), color: '#F59E0B' },
                    { emoji: '✅', value: sportifs.reduce((acc, s) => acc + (s.completed_bookings || 0), 0), label: tr("Séances terminées"), color: '#22C55E' },
                    { emoji: '💬', value: sportifs.filter(s => !s.next_booking && !s.last_booking).length, label: tr("Sans activité"), color: '#9CA3AF' },
                  ].map(({ emoji, value, label, color }) => (
                    <Grid size={{ xs: 6, sm: 3 }} key={tr(label)} sx={{ display: 'flex' }}>
                      <Box sx={{ p: '2px', borderRadius: '20px', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', width: '100%', transition: 'all 0.15s', '&:hover': { boxShadow: `0 6px 28px ${color}55`, transform: 'translateY(-2px)' } }}>
                        <Box sx={{ p: 2, borderRadius: '18px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.3, height: '100%', bgcolor: 'background.paper' }}>
                          <Typography sx={{ fontSize: 24, lineHeight: 1, mb: 0.3 }}>{emoji}</Typography>
                          <Typography variant="h5" fontWeight={900} sx={{ color, lineHeight: 1.1, textShadow: 'none' }}>{value}</Typography>
                          <Typography variant="caption" sx={{ color: '#9CA3AF', lineHeight: 1.2, fontSize: '0.7rem' }}>{tr(label)}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                  <Typography variant="h6" fontWeight={700}>{tr("Liste des Sportifs")} <Chip label={sportifs.length} size="small" sx={{ ml: 1 }} /></Typography>
                  <ToggleButtonGroup value={viewModeSportifs} exclusive onChange={(_, v) => v && setViewModeSportifs(v)} size="small">
                    <ToggleButton value="grid" title={tr("Vue grille")}><ViewModule fontSize="small" /></ToggleButton>
                    <ToggleButton value="list" title={tr("Vue liste")}><ViewList fontSize="small" /></ToggleButton>
                  </ToggleButtonGroup>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                  {([{ label: tr("Excellent"), color: '#22C55E', range: '70-100' }, { label: tr("Correct"), color: '#F59E0B', range: '45-69' }, { label: tr("À améliorer"), color: '#EF4444', range: '0-44' }, { label: tr("Non évalué"), color: '#9CA3AF', range: '-' }] as const).map(({ label, color, range }) => {
                    const count = sportifs.filter(s => {
                      const sc = s.latest_score;
                      if (label === 'Excellent') return sc != null && sc >= 70;
                      if (label === 'Correct') return sc != null && sc >= 45 && sc < 70;
                      if (label === 'À améliorer') return sc != null && sc < 45;
                      return sc == null;
                    }).length;
                    const isActive = levelFilter === label;
                    return (
                      <Chip
                        key={tr(label)}
                        size="small"
                        label={`${tr(label)} (${range}) · ${count}`}
                        onClick={() => setLevelFilter(isActive ? null : label)}
                        sx={{
                          fontSize: '0.65rem', height: 22, fontWeight: 700, cursor: 'pointer',
                          bgcolor: isActive ? color : `${color}22`,
                          color: isActive ? '#fff' : color,
                          border: `1px solid ${color}`,
                          transition: 'all 0.15s',
                          '&:hover': { bgcolor: isActive ? color : `${color}44` },
                        }}
                      />
                    );
                  })}
                  {levelFilter && (
                    <Chip size="small" label="✕ Tout afficher" onClick={() => setLevelFilter(null)}
                      sx={{ fontSize: '0.65rem', height: 22, fontWeight: 700, cursor: 'pointer' }} />
                  )}
                </Box>

                {sportifs.length === 0 ? (
                  <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography color="text.secondary">{tr("Aucun sportif associé pour le moment.")}</Typography>
                  </Box>
                ) : viewModeSportifs === 'list' ? (
                  /* ── VUE LISTE sportifs compact ── */
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, p: 1 }}>
                    {[...sportifs]
                      .sort((a, b) => (b.latest_score ?? -1) - (a.latest_score ?? -1))
                      .filter(s => {
                        if (!levelFilter) return true;
                        const sc = s.latest_score;
                        if (levelFilter === 'Excellent') return sc != null && sc >= 70;
                        if (levelFilter === 'Correct') return sc != null && sc >= 45 && sc < 70;
                        if (levelFilter === 'À améliorer') return sc != null && sc < 45;
                        return sc == null;
                      })
                      .map((sportif, idx) => {
                      const score = sportif.latest_score;
                      const levelColor = score == null ? '#9CA3AF' : score >= 70 ? '#22C55E' : score >= 45 ? '#F59E0B' : '#EF4444';
                      const levelLabel = score == null ? 'Non évalué' : score >= 70 ? 'Excellent' : score >= 45 ? 'Correct' : 'À améliorer';
                      return (
                        <Paper key={sportif.id} variant="outlined" sx={{ borderRadius: 2, borderLeft: `4px solid ${levelColor}`, overflow: 'hidden', cursor: 'pointer', '&:hover': { boxShadow: 2 } }} onClick={() => handleViewSportif(sportif)}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 1, flexWrap: 'wrap' }}>
                            {/* Rang + nom */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0, flex: '1 1 130px' }}>
                              <Typography variant="caption" fontWeight={900} sx={{ color: levelColor, minWidth: 22 }}>#{idx + 1}</Typography>
                              <Box sx={{ minWidth: 0 }}>
                                <Typography variant="body2" fontWeight={800} noWrap>{sportif.username}</Typography>
                                <Typography variant="caption" color="text.secondary" noWrap>{sportif.email}</Typography>
                              </Box>
                            </Box>
                            {/* Niveau + score */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                              <Chip label={levelLabel} size="small" sx={{ fontSize: '0.65rem', height: 20, fontWeight: 800, bgcolor: `${levelColor}22`, color: levelColor, border: `1px solid ${levelColor}55` }} />
                              {score != null && <Chip label={`${(score / 10).toFixed(1).replace('.', ',')}/10`} size="small" variant="outlined" sx={{ fontSize: '0.65rem', height: 20, fontWeight: 700, borderColor: levelColor, color: levelColor }} />}
                            </Box>
                            {/* Prochaine séance */}
                            <Box sx={{ flex: '1 1 120px', minWidth: 0, display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                              <Schedule sx={{ fontSize: 12, flexShrink: 0 }} />
                              <Typography variant="caption" noWrap>
                                {sportif.next_booking
                                  ? format(parseISO(sportif.next_booking), 'dd MMM yy HH:mm', { locale: dateLocale })
                                  : sportif.last_booking
                                    ? `Dern: ${format(parseISO(sportif.last_booking), 'dd MMM yy', { locale: dateLocale })}`
                                    : tr("Aucune séance")}
                              </Typography>
                            </Box>
                            {/* Actions */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0, flexWrap: 'wrap' }} onClick={(e) => e.stopPropagation()}>
                              <Chip label={`${sportif.completed_bookings}✓`} size="small" sx={{ fontSize: '0.65rem', height: 20, fontWeight: 700, bgcolor: '#22C55E22', color: '#22C55E' }} />
                              <IconButton aria-label={tr("Voir les évaluations")} size="small" onClick={() => selectSportifAndGoTo(sportif, 2)} title={tr("Performances")} sx={{ p: 0.5, bgcolor: 'action.selected', borderRadius: '50%', width: 26, height: 26 }}><Assessment sx={{ fontSize: 13 }} /></IconButton>
                              <IconButton aria-label="Voir l’historique" size="small" onClick={() => selectSportifAndGoTo(sportif, 1)} title={tr("Séances")} sx={{ p: 0.5, bgcolor: 'action.selected', borderRadius: '50%', width: 26, height: 26 }}><History sx={{ fontSize: 13 }} /></IconButton>
                              <IconButton aria-label={tr("Ouvrir la conversation")} size="small" onClick={() => navigate('/messages', { state: { recipient: sportif, roleMode: 'COACH' } })} title={tr("Message")} sx={{ p: 0.5, bgcolor: 'primary.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'primary.dark' } }}><Chat sx={{ fontSize: 13 }} /></IconButton>
                              <IconButton aria-label={tr("Suivant")} size="small" onClick={() => handleViewSportif(sportif)} title="Voir profil" sx={{ p: 0.5, bgcolor: 'error.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'error.dark' } }}><ArrowForwardIos sx={{ fontSize: 12 }} /></IconButton>
                            </Box>
                          </Box>
                        </Paper>
                      );
                    })}
                  </Box>
                ) : (
                  /* ── VUE GRILLE sportifs compact ── */
                  <Grid container spacing={isMobile ? 1 : 1.5} sx={{ p: 1 }}>
                    {[...sportifs]
                      .sort((a, b) => (b.latest_score ?? -1) - (a.latest_score ?? -1))
                      .filter(s => {
                        if (!levelFilter) return true;
                        const sc = s.latest_score;
                        if (levelFilter === 'Excellent') return sc != null && sc >= 70;
                        if (levelFilter === 'Correct') return sc != null && sc >= 45 && sc < 70;
                        if (levelFilter === 'À améliorer') return sc != null && sc < 45;
                        return sc == null;
                      })
                      .map((sportif, idx) => {
                      const score = sportif.latest_score;
                      const levelColor = score == null ? '#9CA3AF' : score >= 70 ? '#22C55E' : score >= 45 ? '#F59E0B' : '#EF4444';
                      const levelLabel = score == null ? 'Non évalué' : score >= 70 ? 'Excellent' : score >= 45 ? 'Correct' : 'À améliorer';
                      return (
                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={sportif.id}>
                          <Card variant="outlined" sx={{ borderRadius: 2, cursor: 'pointer', transition: 'box-shadow 0.2s', '&:hover': { boxShadow: 3 }, borderTop: `4px solid ${levelColor}` }} onClick={() => handleViewSportif(sportif)}>
                            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 }, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                              {/* Header avec rang */}
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                                <Typography variant="caption" fontWeight={900} sx={{ color: levelColor, minWidth: 18 }}>#{idx + 1}</Typography>
                                <Avatar sx={{ bgcolor: levelColor, width: 32, height: 32, fontSize: '0.85rem', fontWeight: 700, flexShrink: 0 }}>{sportif.username.charAt(0).toUpperCase()}</Avatar>
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                  <Typography variant="body2" fontWeight={800} noWrap>{sportif.username}</Typography>
                                  <Typography variant="caption" color="text.secondary" noWrap>{sportif.email}</Typography>
                                </Box>
                              </Box>
                              {/* Niveau + score */}
                              <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                <Chip size="small" label={levelLabel} sx={{ fontSize: '0.65rem', height: 20, fontWeight: 800, bgcolor: `${levelColor}22`, color: levelColor, border: `1px solid ${levelColor}55` }} />
                                {score != null && <Chip size="small" label={`${(score / 10).toFixed(1).replace('.', ',')}/10`} variant="outlined" sx={{ fontSize: '0.65rem', height: 20, fontWeight: 700, borderColor: levelColor, color: levelColor }} />}
                              </Box>
                              <Divider />
                              {/* Séance */}
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: 'text.secondary' }}>
                                <Schedule sx={{ fontSize: 13, flexShrink: 0 }} />
                                <Typography variant="caption" noWrap>
                                  {sportif.next_booking
                                    ? format(parseISO(sportif.next_booking), 'dd MMM yyyy HH:mm', { locale: dateLocale })
                                    : sportif.last_booking
                                      ? `Dern: ${format(parseISO(sportif.last_booking), 'dd MMM yy', { locale: dateLocale })}`
                                      : tr("Aucune séance")}
                                </Typography>
                              </Box>
                              {/* Stats */}
                              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                <Chip size="small" label={`${sportif.total_bookings} séances`} variant="outlined" sx={{ fontSize: '0.65rem', height: 20 }} />
                                <Chip size="small" label={`${sportif.completed_bookings}✓`} sx={{ fontSize: '0.65rem', height: 20, bgcolor: '#22C55E22', color: '#22C55E' }} />
                              </Box>
                              {/* Actions */}
                              <Box sx={{ display: 'flex', gap: 0.75, justifyContent: 'flex-end' }} onClick={(e) => e.stopPropagation()}>
                                <IconButton aria-label={tr("Voir les évaluations")} size="small" onClick={() => selectSportifAndGoTo(sportif, 2)} title={tr("Performances")} sx={{ p: 0.5, bgcolor: 'action.selected', borderRadius: '50%', width: 26, height: 26 }}><Assessment sx={{ fontSize: 13 }} /></IconButton>
                                <IconButton aria-label="Voir l’historique" size="small" onClick={() => selectSportifAndGoTo(sportif, 1)} title={tr("Séances")} sx={{ p: 0.5, bgcolor: 'action.selected', borderRadius: '50%', width: 26, height: 26 }}><History sx={{ fontSize: 13 }} /></IconButton>
                                <IconButton aria-label={tr("Ouvrir la conversation")} size="small" onClick={() => navigate('/messages', { state: { recipient: sportif, roleMode: 'COACH' } })} title={tr("Message")} sx={{ p: 0.5, bgcolor: 'primary.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'primary.dark' } }}><Chat sx={{ fontSize: 13 }} /></IconButton>
                                <IconButton aria-label={tr("Suivant")} size="small" onClick={() => handleViewSportif(sportif)} title="Voir profil" sx={{ p: 0.5, bgcolor: 'error.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'error.dark' } }}><ArrowForwardIos sx={{ fontSize: 12 }} /></IconButton>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                )}
              </Box>
              </>
            )}

            {/* TabPanel 2: Séances */}
            {tabValue === 2 && (
              <>
                {/* KPIs Séances */}
                {(() => {
                  const now = new Date();
                  const thisMonth = now.getMonth();
                  const thisYear = now.getFullYear();
                  const revenueMonth = bookings
                    .filter(b => b.status === 'COMPLETED' && b.latest_payment_status === 'COMPLETED' && new Date(b.start_time).getMonth() === thisMonth && new Date(b.start_time).getFullYear() === thisYear)
                    .reduce((acc, b) => acc + (Number(b.program_details?.price) || 0), 0);
                  return (
                    <Grid container spacing={isMobile ? 1 : 2} sx={{ mb: 3 }} alignItems="stretch">
                      {[
                        { emoji: '📋', value: bookings.filter(b => b.status !== 'CANCELLED').length, label: 'Total', color: '#6366F1', filterKey: 'ALL' },
                        { emoji: '⏳', value: bookings.filter(b => b.status === 'PENDING').length, label: tr("En attente"), color: '#F59E0B', filterKey: 'PENDING' },
                        { emoji: '🔵', value: bookings.filter(b => b.status === 'CONFIRMED').length, label: tr("Confirmées"), color: '#3B82F6', filterKey: 'CONFIRMED' },
                        { emoji: '✅', value: bookings.filter(b => b.status === 'COMPLETED').length, label: tr("Terminées"), color: '#22C55E', filterKey: 'COMPLETED' },
                        { emoji: '❌', value: bookings.filter(b => b.status === 'CANCELLED').length, label: tr("Annulées"), color: '#EF4444', filterKey: 'CANCELLED' },
                        { emoji: '💶', value: `${revenueMonth} €`, label: tr("Revenus du mois"), color: '#10B981', filterKey: null },
                      ].map(({ emoji, value, label, color, filterKey }) => (
                        <Grid size={{ xs: 6, sm: 4, md: 2 }} key={tr(label)} sx={{ display: 'flex' }}>
                          <Box onClick={() => filterKey && setBookingFilter(filterKey)} sx={{ p: '2px', borderRadius: '20px', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', cursor: filterKey ? 'pointer' : 'default', width: '100%', transition: 'all 0.15s', '&:hover': filterKey ? { boxShadow: `0 6px 28px ${color}60`, transform: 'translateY(-2px)' } : {} }}>
                            <Box sx={{ p: 2, borderRadius: '18px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 0.3, height: '100%', bgcolor: 'background.paper' }}>
                              <Typography sx={{ fontSize: 24, lineHeight: 1, mb: 0.3 }}>{emoji}</Typography>
                              <Typography variant="h5" fontWeight={900} sx={{ color, lineHeight: 1.1, textShadow: 'none' }}>{value}</Typography>
                              <Typography variant="caption" sx={{ color: '#9CA3AF', lineHeight: 1.2, fontSize: '0.7rem' }}>{tr(label)}</Typography>
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  );
                })()}
              <Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" fontWeight={700}>{tr("Historique des séances")}</Typography>
                    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
                      <Button
                        variant="contained"
                        startIcon={<Add />}
                        size="small"
                        onClick={() => {
                          const now2 = new Date();
                          const plus1h2 = new Date(now2.getTime() + 60 * 60 * 1000);
                          if (accessLocked) {
                            setSubscriptionRequiredOpen(true);
                            return;
                          }
                          setNewAvailability({ start_time: now2.toISOString().slice(0, 16), end_time: plus1h2.toISOString().slice(0, 16), is_recurring: false, max_participants: 1 });
                          setPlanSessionData({ sportif_ids: [], program_id: '', note: '' });
                          setPlanModalError('');
                          setEditingAvailId(null);
                          setPlanModalMode('session');
                          setOpenModal(true);
                        }}
                        sx={{ borderRadius: 3, fontWeight: 700, px: 2 }}
                      >
                        {isMobile ? tr("Séance") : tr("Nouvelle séance")}
                      </Button>
                      <ToggleButtonGroup value={viewModeSeances} exclusive onChange={(_, v) => v && setViewModeSeances(v)} size="small">
                        <ToggleButton value="grid" title={tr("Vue grille")}><ViewModule fontSize="small" /></ToggleButton>
                        <ToggleButton value="list" title={tr("Vue liste")}><ViewList fontSize="small" /></ToggleButton>
                      </ToggleButtonGroup>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      {['ALL', 'PENDING', 'CONFIRMED', 'COMPLETED', 'CANCELLED'].map((s) => (
                        <Box
                          key={s}
                          onClick={() => setBookingFilter(s)}
                          sx={{
                            display: 'inline-flex', alignItems: 'center', gap: 0.6,
                            px: 1.4, py: 0.5, borderRadius: '999px', cursor: 'pointer',
                            fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.02em',
                            transition: 'all 0.15s ease',
                            ...(bookingFilter === s
                              ? { bgcolor: 'primary.main', color: 'primary.contrastText', border: '1px solid transparent' }
                              : { bgcolor: 'action.hover', color: 'text.secondary', border: '1px solid', borderColor: 'divider', '&:hover': { bgcolor: 'action.selected' } }
                            ),
                          }}
                        >
                          {s !== 'ALL' && <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: bookingStatusConfig[s]?.dot ?? 'currentColor', flexShrink: 0, opacity: bookingFilter === s ? 1 : 0.6 }} />}
                          {s === 'ALL' ? tr("Tous") : tr(bookingStatusConfig[s]?.label ?? s)}
                        </Box>
                      ))}
                    </Box>
                    </Box>
                  {/* Sélecteur de sportif */}
                  <FormControl size="small" sx={{ minWidth: 240 }}>
                    <InputLabel>{tr("Sportif")}</InputLabel>
                    <Select
                      value={selectedSportif?.id ?? 'all'}
                      label={tr("Sportif")}
                      onChange={(e) => {
                        if (e.target.value === 'all') setSelectedSportif(null);
                        else selectSportifById(Number(e.target.value));
                      }}
                    >
                      <MenuItem value="all">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Avatar sx={{ bgcolor: 'text.disabled', width: 24, height: 24, fontSize: '0.7rem' }}>T</Avatar>
                           {tr("Tous les sportifs")} </Box>
                      </MenuItem>
                      {sportifs.map((s) => (
                        <MenuItem key={s.id} value={s.id}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar sx={{ bgcolor: 'primary.main', width: 24, height: 24, fontSize: '0.7rem' }}>{s.username.charAt(0).toUpperCase()}</Avatar>
                            {s.username}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                {(() => {
                  const filtered = bookings
                    .filter(b => (bookingFilter === 'ALL' || b.status === bookingFilter) && (!selectedSportif || b.sportif_details?.id === selectedSportif.id))
                    .sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());
                  if (filtered.length === 0) return <Box sx={{ p: 4, textAlign: 'center' }}><Typography color="text.secondary">{tr("Aucune séance trouvée.")}</Typography></Box>;
                  // Regrouper par jour
                  const grouped: Record<string, typeof filtered> = {};
                  filtered.forEach(bk => {
                    const day = bk.start_time.substring(0, 10);
                    if (!grouped[day]) grouped[day] = [];
                    grouped[day].push(bk);
                  });
                  const sortedDays = Object.keys(grouped).sort();
                  if (viewModeSeances === 'list') return (
                    /* ── VUE LISTE séances groupées par jour ── */
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 1 }}>
                      {sortedDays.map(day => (
                        <Box key={day}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75, px: 0.5 }}>
                            <CalendarMonth sx={{ fontSize: 15, color: 'primary.main' }} />
                            <Typography variant="caption" fontWeight={900} color="primary.main" sx={{ textTransform: 'capitalize', fontSize: '0.78rem' }}>
                              {format(parseISO(day), 'EEEE d MMMM yyyy', { locale: dateLocale })}
                            </Typography>
                            <Chip label={grouped[day].length} size="small" sx={{ height: 16, fontSize: '0.6rem', fontWeight: 700 }} />
                          </Box>
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      {grouped[day].map((bk) => (
                        <Paper key={bk.id} variant="outlined" sx={{ borderRadius: 2, borderLeft: `3px solid ${bookingStatusConfig[bk.status]?.dot ?? '#9CA3AF'}`, overflow: 'hidden', '&:hover': { boxShadow: 2 } }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, py: 1, flexWrap: 'wrap' }}>
                            {/* Sportif + programme */}
                            <Box sx={{ minWidth: 0, flex: '1 1 110px' }}>
                              <Typography variant="body2" fontWeight={800} noWrap>{bk.sportif_details?.username}</Typography>
                              <Typography variant="caption" color="text.secondary" noWrap>{bk.program_details?.title || tr("Séance libre")}</Typography>
                            </Box>
                            {/* Date */}
                            <Box sx={{ flex: '1 1 130px', minWidth: 0, display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                              <Schedule sx={{ fontSize: 12, flexShrink: 0 }} />
                              <Typography variant="caption" noWrap>{format(parseISO(bk.start_time), 'dd MMM yy HH:mm', { locale: dateLocale })}</Typography>
                            </Box>
                            {/* Badges + actions */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0, flexWrap: 'wrap' }}>
                              <PaymentBadge status={bk.latest_payment_status || 'UNPAID'} />
                              <StatusBadge status={bk.status} isCoachCreated={bk.is_coach_created} />
                              {(bk.status === 'CONFIRMED' || bk.status === 'COMPLETED') && bk.latest_payment_status !== 'COMPLETED' && (
                                <IconButton aria-label={tr("Marquer comme payé")} size="small" onClick={() => setConfirmAction({ type: 'pay', bookingId: bk.id })} title={tr("Marquer payé")} sx={{ p: 0.5, bgcolor: '#16A34A', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: '#15803D' } }}>
                                  <Euro sx={{ fontSize: 14 }} />
                                </IconButton>
                              )}
                              <IconButton aria-label={tr("Ouvrir la conversation")} size="small" onClick={() => navigate('/messages', { state: { recipient: bk.sportif_details, roleMode: 'COACH' } })} sx={{ p: 0.5, bgcolor: 'primary.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'primary.dark' } }}>
                                <Chat sx={{ fontSize: 14 }} />
                              </IconButton>
                              {bk.status === 'PENDING' && (<>
                                <IconButton aria-label="Valider" size="small" onClick={() => handleBookingAction(bk.id, 'confirm')} sx={{ p: 0.5, bgcolor: 'success.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'success.dark' } }}>
                                  <CheckCircle sx={{ fontSize: 14 }} />
                                </IconButton>
                                <IconButton aria-label={tr("Annuler")} size="small" onClick={() => setConfirmAction({ type: 'cancel', bookingId: bk.id })} sx={{ p: 0.5, bgcolor: 'error.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'error.dark' } }}>
                                  <Cancel sx={{ fontSize: 14 }} />
                                </IconButton>
                              </>)}
                              {bk.status === 'CONFIRMED' && (
                                <IconButton aria-label="Valider" size="small" onClick={() => setConfirmAction({ type: 'complete', bookingId: bk.id })} title="Terminer" sx={{ p: 0.5, bgcolor: 'warning.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'warning.dark' } }}>
                                  <CheckCircle sx={{ fontSize: 14 }} />
                                </IconButton>
                              )}
                            </Box>
                          </Box>
                        </Paper>
                      ))}
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  );
                  /* ── VUE GRILLE séances compact ── */
                  return (
                    <Grid container spacing={isMobile ? 1 : 1.5} sx={{ p: 1 }}>
                      {filtered.map((bk) => (
                        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={bk.id}>
                          <Card variant="outlined" sx={{ borderRadius: 2, borderTop: `3px solid ${bookingStatusConfig[bk.status]?.dot ?? '#9CA3AF'}`, transition: 'box-shadow 0.2s', '&:hover': { boxShadow: 3 } }}>
                            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 }, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                              {/* Header */}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 0 }}>
                                  <Typography variant="body2" fontWeight={800} noWrap>{bk.sportif_details?.username}</Typography>
                                  <Typography variant="caption" color="text.secondary" noWrap>{bk.program_details?.title || tr("Séance personnalisée")}</Typography>
                                </Box>
                                <StatusBadge status={bk.status} isCoachCreated={bk.is_coach_created} />
                              </Box>
                              <Divider />
                              {/* Date */}
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: 'text.secondary' }}>
                                <Schedule sx={{ fontSize: 14, flexShrink: 0 }} />
                                <Typography variant="caption">{format(parseISO(bk.start_time), 'dd MMM yyyy HH:mm', { locale: dateLocale })}</Typography>
                              </Box>
                              {/* Paiement */}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'action.hover', px: 1, py: 0.5, borderRadius: 1 }}>
                                <PaymentBadge status={bk.latest_payment_status || 'UNPAID'} />
                                {(bk.status === 'CONFIRMED' || bk.status === 'COMPLETED') && bk.latest_payment_status !== 'COMPLETED' && (
                                  <IconButton aria-label={tr("Marquer comme payé")} size="small" onClick={() => setConfirmAction({ type: 'pay', bookingId: bk.id })} title={tr("Marquer payé")} sx={{ p: 0.4, bgcolor: '#16A34A', color: 'white', borderRadius: '50%', width: 24, height: 24, '&:hover': { bgcolor: '#15803D' } }}>
                                    <Euro sx={{ fontSize: 13 }} />
                                  </IconButton>
                                )}
                              </Box>
                              {/* Actions */}
                              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
                                <IconButton aria-label={tr("Ouvrir la conversation")} size="small" onClick={() => navigate('/messages', { state: { recipient: bk.sportif_details, roleMode: 'COACH' } })} sx={{ p: 0.5, bgcolor: 'primary.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'primary.dark' } }}>
                                  <Chat sx={{ fontSize: 14 }} />
                                </IconButton>
                                {bk.status === 'PENDING' && (<>
                                  <IconButton aria-label={tr("Annuler")} size="small" onClick={() => setConfirmAction({ type: 'cancel', bookingId: bk.id })} sx={{ p: 0.5, bgcolor: 'error.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'error.dark' } }}>
                                    <Cancel sx={{ fontSize: 14 }} />
                                  </IconButton>
                                  <IconButton aria-label="Valider" size="small" onClick={() => handleBookingAction(bk.id, 'confirm')} sx={{ p: 0.5, bgcolor: 'success.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'success.dark' } }}>
                                    <CheckCircle sx={{ fontSize: 14 }} />
                                  </IconButton>
                                </>)}
                                {bk.status === 'CONFIRMED' && (
                                  <IconButton aria-label="Valider" size="small" onClick={() => setConfirmAction({ type: 'complete', bookingId: bk.id })} title="Terminer" sx={{ p: 0.5, bgcolor: 'warning.main', color: 'white', borderRadius: '50%', width: 26, height: 26, '&:hover': { bgcolor: 'warning.dark' } }}>
                                    <CheckCircle sx={{ fontSize: 14 }} />
                                  </IconButton>
                                )}
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  );
                })()}
              </Box>
              </>
            )}

        {/* TabPanel 3: Performances */}
        {tabValue === 3 && (
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="h6" fontWeight={700}>{tr("Performances")}</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {!showPerformanceForm && selectedSportif && (
                      <Button variant="contained" startIcon={<Add />} onClick={() => setShowPerformanceForm(true)}>{tr("Nouvelle Évaluation")}</Button>
                    )}
                  {/* Sélecteur de sportif */}
                  <FormControl size="small" sx={{ minWidth: 200 }}>
                    <InputLabel>{tr("Sportif")}</InputLabel>
                    <Select
                      value={selectedSportif?.id ?? ''}
                      label={tr("Sportif")}
                      onChange={(e) => selectSportifById(Number(e.target.value))}
                    >
                      {sportifs.map((s) => (
                        <MenuItem key={s.id} value={s.id}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar sx={{ bgcolor: 'primary.main', width: 24, height: 24, fontSize: '0.7rem' }}>{s.username.charAt(0).toUpperCase()}</Avatar>
                            {s.username}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  </Box>
                </Box>
                <Box>
                  {!selectedSportif ? (
                    <Box sx={{ textAlign: 'center', py: 6 }}>
                      <Typography color="text.secondary" sx={{ mb: 1 }}>{tr("Sélectionnez un sportif ci-dessus pour voir ses performances.")}</Typography>
                      <Typography variant="caption" color="text.secondary">{tr("Vous pouvez aussi cliquer sur \"Performances\" directement depuis la liste.")}</Typography>
                    </Box>
                  ) : showPerformanceForm ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" fontWeight={700}>{editingPerformanceId ? tr("Modifier l'Évaluation") : tr("Nouvelle Évaluation")} — {selectedSportif.username}</Typography>
                        <Button variant="outlined" size="small" onClick={resetPerfForm}>{tr("Annuler")}</Button>
                      </Box>
                      <TextField label={tr("Date")} type="date" size="small" value={newPerformance.date} onChange={(e) => setNewPerformance({...newPerformance, date: e.target.value})} InputLabelProps={{ shrink: true }} sx={{ mb: 1 }} />
                      <FormControl size="small" sx={{ mb: 1 }}>
                        <InputLabel><LinkIcon sx={{ fontSize: 14, mr: 0.5 }} />{tr("Séance liée (optionnel)")}</InputLabel>
                        <Select
                          value={perfLinkedBookingId}
                          label={tr("Séance liée (optionnel)")}
                          onChange={(e) => setPerfLinkedBookingId(e.target.value as number | '')}
                        >
                          <MenuItem value="">{tr("Aucune")}</MenuItem>
                          {(() => {
                            const evaluatedBookingIds = new Set(
                              performances
                                .filter(p => p.booking && p.id !== editingPerformanceId)
                                .map(p => p.booking)
                            );
                            return bookings
                              .filter(b =>
                                (b.sportif === selectedSportif?.id || b.sportif_details?.id === selectedSportif?.id) &&
                                !evaluatedBookingIds.has(b.id)
                              )
                              .map((b) => (
                                <MenuItem key={b.id} value={b.id}>
                                  {b.start_time ? format(new Date(b.start_time), 'dd/MM/yyyy HH:mm') : `Séance #${b.id}`}
                                </MenuItem>
                              ));
                          })()}
                        </Select>
                      </FormControl>
                      {([
                        { key: 'endurance',          label: 'Endurance',            color: '#4caf50' },
                        { key: 'technical_mastery',  label: tr("Maîtrise Technique"),   color: '#2196f3' },
                        { key: 'mental_strength',    label: 'Force Mentale',         color: '#2196f3' },
                        { key: 'motivation',         label: 'Motivation',            color: '#9c27b0' },
                        { key: 'explosivite',        label: tr("Explosivité"),           color: '#06B6D4' },
                        { key: 'tactique',           label: 'Tactique',              color: '#8B5CF6' },
                        { key: 'volontaire',         label: 'Volontaire',            color: '#F59E0B' },
                        { key: 'fatigue_level',      label: 'En forme',              color: '#795548' },
                        { key: 'stress_level',       label: tr("Gestion Émotion"),       color: '#f44336' },
                        { key: 'coordination',       label: 'Coordination',          color: '#0288d1' },
                      ] as { key: keyof typeof newPerformance; label: string; color: string }[]).map(({ key, label, color }) => (
                        <RatingSquares
                          key={key}
                          label={tr(label)}
                          color={color}
                          value={(newPerformance as any)[key]}
                          onChange={(v) => {
                            const updated = { ...newPerformance, [key]: v };
                            const keys: (keyof typeof newPerformance)[] = ['endurance','technical_mastery','mental_strength','motivation','explosivite','tactique','volontaire','fatigue_level','stress_level','coordination'];
                            const avg = keys.reduce((s, k) => s + ((updated as any)[k] || 0), 0) / keys.length;
                            updated.global_score = Math.round(avg * 10);
                            setNewPerformance(updated);
                          }}
                        />
                      ))}
                      <Box sx={{ mt: 1, mb: 1, p: 1.5, borderRadius: 2, bgcolor: 'action.hover' }}>
                        <Typography variant="body2" fontWeight={700}>{tr("Score Global (moyenne automatique) :")} {(newPerformance.global_score / 10).toFixed(1).replace('.', ',')}/10</Typography>
                      </Box>
                      <TextField label="Notes / Commentaires" multiline rows={3} fullWidth value={newPerformance.notes} onChange={(e) => setNewPerformance({...newPerformance, notes: e.target.value})} />
                      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 1 }}>
                        <Button onClick={resetPerfForm}>{tr("Annuler")}</Button>
                        <Button variant="contained" startIcon={<Save />} onClick={handleSavePerformance}>{editingPerformanceId ? tr("Mettre à jour") : tr("Enregistrer")}</Button>
                      </Box>
                    </Box>
                  ) : (
                    performances.length === 0 ? (
                      <Box sx={{ textAlign: 'center', py: 6 }}>
                        <Typography color="text.secondary">{tr("Aucune évaluation enregistrée.")}</Typography>
                        <Typography variant="caption" color="text.secondary">{tr("Sélectionnez d'abord un sportif dans la liste pour voir ses performances.")}</Typography>
                      </Box>
                    ) : (
                      <>
                      {/* ── Graphiques ── */}
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>{tr("Graphiques —")} {selectedSportif?.username}</Typography>
                        <Grid container spacing={2}>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <PerformanceProfile data={radarData} date={latestPerformance?.date} />
                          </Grid>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <PerformanceEvolution data={chartData} series={["endurance","technical_mastery","mental_strength","explosivite","tactique","volontaire","global_score"]} wellbeing={false} />
                          </Grid>
                          <Grid size={{ xs: 12 }}>
                            <PerformanceEvolution data={chartData} series={["motivation","coordination","stress_level","fatigue_level","explosivite","tactique","volontaire"]} wellbeing={true} />
                          </Grid>

                          {/* ── Jauge de forme ── */}
                          <Grid size={{ xs: 12, md: 5 }}>
                            <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 260 }}>
                              <Typography variant="body2" fontWeight={700} sx={{ mb: 2 }}>{tr("Score de la dernière séance —")} {selectedSportif?.username}</Typography>
                              {latestPerformance && (() => {
                                // latestPerformance vient de chartData (global_score deja ramene sur /10) :
                                // on repasse sur /100 pour la logique commune (jauge, seuils de couleur).
                                const score = (latestPerformance.global_score || 0) * 10;
                                const pct = Math.round(score);
                                const color = pct >= 70 ? '#22C55E' : pct >= 45 ? '#F59E0B' : '#EF4444';
                                const label = pct >= 70 ? 'Excellent' : pct >= 45 ? 'Correct' : 'À améliorer';
                                const r = 70; const circ = 2 * Math.PI * r;
                                const dash = (pct / 100) * circ;
                                return (
                                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                                    <Box sx={{ position: 'relative', width: 170, height: 170 }}>
                                      <svg width="170" height="170" viewBox="0 0 170 170">
                                        <circle cx="85" cy="85" r={r} fill="none" stroke="#e5e7eb" strokeWidth="14" />
                                        <circle cx="85" cy="85" r={r} fill="none" stroke={color} strokeWidth="14"
                                          strokeDasharray={`${dash} ${circ - dash}`}
                                          strokeLinecap="round"
                                          transform="rotate(-90 85 85)"
                                          style={{ transition: 'stroke-dasharray 0.6s ease' }}
                                        />
                                      </svg>
                                      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', textAlign: 'center' }}>
                                        <Typography variant="h4" fontWeight={900} sx={{ color, lineHeight: 1 }}>{(score / 10).toFixed(1).replace('.', ',')}</Typography>
                                        <Typography variant="caption" color="text.secondary">/10</Typography>
                                      </Box>
                                    </Box>
                                    <Chip label={tr(label)} size="small" sx={{ bgcolor: color, color: 'white', fontWeight: 700 }} />
                                    <Typography variant="caption" color="text.secondary">
                                      {format(parseISO(latestPerformance.date), 'dd MMMM yyyy', { locale: dateLocale })}
                                    </Typography>
                                  </Box>
                                );
                              })()}
                            </Paper>
                            {/* ── Score moyen des séances : moyenne de toutes les séances notées ── */}
                            <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 260, mt: 2 }}>
                              <Typography variant="body2" fontWeight={700} sx={{ mb: 2 }}>{tr("Score moyen des séances —")} {selectedSportif?.username}</Typography>
                              {performances.length > 0 ? (() => {
                                const score = performances.reduce((s: number, p: any) => s + (p.global_score || 0), 0) / performances.length;
                                const pct = Math.round(score);
                                const color = pct >= 70 ? '#22C55E' : pct >= 45 ? '#F59E0B' : '#EF4444';
                                const label = pct >= 70 ? 'Excellent' : pct >= 45 ? 'Correct' : 'À améliorer';
                                const r = 70; const circ = 2 * Math.PI * r;
                                const dash = (pct / 100) * circ;
                                return (
                                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                                    <Box sx={{ position: 'relative', width: 170, height: 170 }}>
                                      <svg width="170" height="170" viewBox="0 0 170 170">
                                        <circle cx="85" cy="85" r={r} fill="none" stroke="#e5e7eb" strokeWidth="14" />
                                        <circle cx="85" cy="85" r={r} fill="none" stroke={color} strokeWidth="14"
                                          strokeDasharray={`${dash} ${circ - dash}`}
                                          strokeLinecap="round"
                                          transform="rotate(-90 85 85)"
                                          style={{ transition: 'stroke-dasharray 0.6s ease' }}
                                        />
                                      </svg>
                                      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', textAlign: 'center' }}>
                                        <Typography variant="h4" fontWeight={900} sx={{ color, lineHeight: 1 }}>{(score / 10).toFixed(1).replace('.', ',')}</Typography>
                                        <Typography variant="caption" color="text.secondary">/10</Typography>
                                      </Box>
                                    </Box>
                                    <Chip label={tr(label)} size="small" sx={{ bgcolor: color, color: 'white', fontWeight: 700 }} />
                                    <Typography variant="caption" color="text.secondary">
                                       {tr("Moyenne sur")} {performances.length}  {tr("séance")}{performances.length > 1 ? 's' : ''}  {tr("notée")}{performances.length > 1 ? 's' : ''}
                                    </Typography>
                                  </Box>
                                );
                              })() : (
                                <Typography variant="body2" color="text.secondary">{tr("Aucune séance notée.")}</Typography>
                              )}
                            </Paper>
                          </Grid>

                          {/* ── Barres comparatives : dernière séance vs moyenne ── */}
                          <Grid size={{ xs: 12, md: 7 }}>
                            <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, height: 300 }}>
                              <Typography variant="body2" fontWeight={700} sx={{ mb: 1, textAlign: 'center' }}>{tr("Dernière Séance vs Moyenne")}</Typography>
                              {(() => {
                                const axes = [
                                  { key: 'endurance', label: 'Endurance' },
                                  { key: 'technical_mastery', label: 'Technique' },
                                  { key: 'mental_strength', label: 'Mental' },
                                  { key: 'fatigue_level', label: 'En forme' },
                                  { key: 'stress_level', label: 'G. Émotion' },
                                  { key: 'coordination', label: 'Coordination' },
                                  { key: 'motivation', label: 'Motivation' },
                                  { key: 'explosivite', label: 'Explosivité' },
                                  { key: 'tactique', label: 'Tactique' },
                                  { key: 'volontaire', label: 'Volonté' },
                                ];
                                const n = performances.length;
                                const compareData = axes.map(({ key, label }) => ({
                                  name: label,
                                  Dernière: latestPerformance ? ((latestPerformance as any)[key] || 0) : 0,
                                  Moyenne: n > 0 ? Math.round(performances.reduce((s: number, p: any) => s + (p[key] || 0), 0) / n * 10) / 10 : 0,
                                }));
                                return (
                                  <ResponsiveContainer width="100%" height="85%">
                                    <BarChart data={compareData} margin={{ top: 5, right: 10, left: -25, bottom: 30 }}>
                                      <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                      <XAxis dataKey="name" tick={{ fontSize: 10, fill: theme.palette.text.secondary }} angle={-35} textAnchor="end" interval={0} />
                                      <YAxis domain={[0, 10]} axisLine={false} tickLine={false} tick={{ fontSize: 10, fill: theme.palette.text.secondary }} />
                                      <Tooltip formatter={(value: any) => `${Number(value).toLocaleString(locale, { maximumFractionDigits: 1 })} / 10`} contentStyle={{ background: theme.palette.background.paper, color: theme.palette.text.primary, border: `1px solid ${theme.palette.divider}`, borderRadius: 12 }} />
                                      <Legend wrapperStyle={{ fontSize: 11, paddingTop: 4 }} />
                                      <Bar dataKey="Dernière" name="Dernière séance" fill="#D9B76A" radius={[3,3,0,0]} barSize={10} />
                                      <Bar dataKey="Moyenne" name="Moyenne de toutes les séances" fill="#62B5E5" radius={[3,3,0,0]} barSize={10} />
                                    </BarChart>
                                  </ResponsiveContainer>
                                );
                              })()}
                            </Paper>
                          </Grid>

                        </Grid>
                      </Box>
                      {/* ── Historique évaluations (repliable) ── */}
                      <Box
                        onClick={() => setShowHistorique(v => !v)}
                        sx={{
                          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                          cursor: 'pointer', px: 2, py: 1.2, borderRadius: '999px',
                          bgcolor: 'action.hover', mb: showHistorique ? 2 : 0,
                          transition: 'background 0.15s',
                          '&:hover': { bgcolor: 'action.selected' },
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="subtitle1" fontWeight={700}>{tr("Historique des évaluations")}</Typography>
                          <Chip label={performances.length} size="small" />
                        </Box>
                        {showHistorique ? <ExpandLess /> : <ExpandMore />}
                      </Box>
                      <Collapse in={showHistorique}>
                      {performances.map((perf) => (
                        <Paper key={perf.id} variant="outlined" sx={{ mb: 2, p: 2, borderRadius: 2 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                            <Box>
                              <Typography variant="subtitle1" fontWeight={700}>{format(parseISO(perf.date), 'PPP', { locale: dateLocale })}</Typography>
                              {perf.booking && (
                                <Typography variant="caption" color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                  <LinkIcon sx={{ fontSize: 12 }} />  {tr("Séance #")}{perf.booking}
                                </Typography>
                              )}
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Chip label={`${(perf.global_score / 10).toFixed(1).replace('.', ',')}/10`} color="primary" size="small" />
                              <IconButton aria-label={tr("Modifier")} size="small" onClick={() => handleEditPerformance(perf)} title={tr("Modifier")}><Edit fontSize="small" /></IconButton>
                              <IconButton aria-label={tr("Supprimer")} size="small" color="error" onClick={() => handleDeletePerformance(perf.id)} title={tr("Supprimer")}><Delete fontSize="small" /></IconButton>
                            </Box>
                          </Box>
                          <Grid container spacing={1}>
                            {([['Endurance', perf.endurance, 'success.main'], [tr("Technique"), perf.technical_mastery, 'warning.main'], [tr("Mental"), perf.mental_strength, 'error.main'], ['Motivation', perf.motivation, 'primary.main'], [tr("Explosivité"), perf.explosivite, '#06B6D4'], ['Tactique', perf.tactique, '#8B5CF6'], ['Volontaire', perf.volontaire, '#F59E0B'], ['En forme', perf.fatigue_level, 'text.secondary'], [tr("Gestion Émotion"), perf.stress_level, 'text.secondary'], ['Coordination', perf.coordination, '#4caf50']] as [string, number|null|undefined, string][]).map(([label, val, color]) => (
                              <Grid size={{ xs: 4, sm: 3 }} key={String(label)}>
                                <Box sx={{ textAlign: 'center', p: 0.5, bgcolor: 'background.default', borderRadius: 1 }}>
                                  <Typography variant="caption" display="block" color="text.secondary">{tr(label)}</Typography>
                                  <Typography variant="body2" fontWeight={700} color={color as any}>{val !== null && val !== undefined ? val : '-'}</Typography>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                          {perf.notes && <Typography variant="body2" color="text.secondary" sx={{ mt: 1, bgcolor: 'action.hover', p: 1, borderRadius: 1 }}>{perf.notes}</Typography>}
                        </Paper>
                      ))}
                      </Collapse>
                      </>
                    )
                  )}
                </Box>
              </Box>
            )}

        {/* TabPanel 4: Invitations */}
        {tabValue === 4 && (
              <Paper sx={{ borderRadius: 4, overflow: 'hidden' }}>
                <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
                  <Typography variant="h6" fontWeight={700}>{tr("Invitations")}</Typography>
                </Box>
                <Grid container spacing={3} sx={{ p: 3 }}>
                  {/* Formulaire invitation */}
                  <Grid size={{ xs: 12, md: 5 }}>
                    <Stack spacing={2}>
                      <Paper variant="outlined" sx={{ p: 3, borderRadius: 3 }}>
                        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>{tr("Inviter un nouveau sportif")}</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{tr("Envoyez une invitation pour permettre à votre sportif de rejoindre G1Sport.")}</Typography>
                        <Stack spacing={2}>
                          <TextField label={tr("Nom complet (Optionnel)")} fullWidth value={inviteData.name} onChange={(e) => setInviteData({ ...inviteData, name: e.target.value })} />
                          <TextField label="Adresse Email" fullWidth required type="email" value={inviteData.email} onChange={(e) => setInviteData({ ...inviteData, email: e.target.value })} />
                          <TextField label={tr("Message personnalisé (Optionnel)")} fullWidth multiline rows={3} value={inviteData.custom_message} onChange={(e) => setInviteData({ ...inviteData, custom_message: e.target.value })} placeholder={tr("Ajoutez un petit mot personnel...")} />
                          <Button variant="contained" startIcon={<Email />} onClick={handleSendInvite} disabled={!inviteData.email} fullWidth>{tr("Envoyer l'invitation")}</Button>
                        </Stack>
                      </Paper>

                      {/* Aperçu du mail */}
                      <Paper variant="outlined" sx={{ borderRadius: 3, overflow: 'hidden' }}>
                        <Box sx={{ px: 2, py: 1, bgcolor: 'action.hover', borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Email fontSize="small" color="action" />
                          <Typography variant="caption" fontWeight={700} color="text.secondary">{tr("APERÇU DU MAIL")}</Typography>
                        </Box>
                        <Box sx={{ p: 2.5, bgcolor: 'background.default' }}>
                          {/* Header mail */}
                          <Box sx={{ mb: 2, pb: 2, borderBottom: 1, borderColor: 'divider' }}>
                            <Typography variant="caption" color="text.secondary" display="block"><b>De :</b> no-reply@g1sport.fr</Typography>
                            <Typography variant="caption" color="text.secondary" display="block"><b>{tr("À :")}</b> {inviteData.email || 'sportif@email.com'}</Typography>
                            <Typography variant="caption" color="text.secondary" display="block"><b>{tr("Objet :")}</b> {user?.username}  {tr("vous invite à rejoindre G1Sport 🏋️")}</Typography>
                          </Box>
                          {/* Corps — style sombre identique au vrai email */}
                          <Box sx={{ background: '#1e293b', borderRadius: 2, overflow: 'hidden' }}>
                            {/* Header gradient */}
                            <Box sx={{ background: 'linear-gradient(135deg,#0f172a 0%,#1e3a5f 100%)', p: 3, textAlign: 'center' }}>
                              <img src="/g1s-logo-3d.png" alt="G1Sport" style={{ height: 64, display: 'block', margin: '0 auto 12px' }} />
                              <Typography sx={{ fontSize: '1.4rem', fontWeight: 900, color: '#FFD700', letterSpacing: '-0.02em' }}>G1Sport</Typography>
                            </Box>
                            {/* Body */}
                            <Box sx={{ p: '24px 24px 8px' }}>
                              <Typography sx={{ mb: 1.5, color: '#e2e8f0', fontSize: '1rem', fontWeight: 700 }}>
                                 {tr("Bonjour")} {inviteData.name || tr("Sportif")} 👋
                              </Typography>
                              <Typography sx={{ mb: 2, color: '#94a3b8', fontSize: '0.875rem', lineHeight: 1.7 }}>
                                 {tr("Votre coach")} <Box component="span" sx={{ color: '#00bcd4', fontWeight: 700 }}>{user?.username}</Box>  {tr("vous invite à rejoindre")}{' '}
                                <Box component="span" sx={{ color: '#FFD700', fontWeight: 700 }}>G1Sport</Box>  {tr("— la plateforme pour suivre vos entraînements et performances sportives.")} </Typography>
                            </Box>
                            {inviteData.custom_message && (
                              <Box sx={{ mx: 3, mb: 2, p: 1.5, borderLeft: '3px solid #00bcd4', color: '#c7d2e0', fontSize: '0.875rem', fontStyle: 'italic' }}>
                                {inviteData.custom_message}
                              </Box>
                            )}
                            {/* CTA */}
                            <Box sx={{ px: 3, pb: 3, textAlign: 'center' }}>
                              <Box sx={{
                                display: 'inline-block', px: 4, py: 1.5,
                                background: 'linear-gradient(135deg,#00bcd4,#0097a7)',
                                color: '#fff', borderRadius: '50px',
                                fontWeight: 700, fontSize: '0.9rem',
                                boxShadow: '0 4px 16px rgba(0,188,212,0.4)'
                              }}>
                                 {tr("Créer mon compte")} </Box>
                            </Box>
                            {/* Footer */}
                            <Box sx={{ background: '#0f172a', p: '16px 24px', textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                              <Typography sx={{ color: '#475569', fontSize: '0.75rem' }}>
                                © 2025 G1Sport · <Box component="span" sx={{ color: '#00bcd4' }}>g1sport.fr</Box>
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Paper>
                    </Stack>
                  </Grid>
                  {/* Historique invitations */}
                  <Grid size={{ xs: 12, md: 7 }}>
                    <Paper variant="outlined" sx={{ p: 3, borderRadius: 3 }}>
                      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>{tr("Historique des invitations")}</Typography>
                      {invitations.length === 0 ? (
                        <Box sx={{ textAlign: 'center', py: 4 }}>
                          <Typography color="text.secondary">{tr("Aucune invitation envoyée.")}</Typography>
                        </Box>
                      ) : (
                        <List disablePadding>
                          {invitations.map((inv) => (
                            <React.Fragment key={inv.id}>
                              <ListItem alignItems="flex-start" sx={{ px: 0 }}>
                                <ListItemAvatar>
                                  <Avatar sx={{ bgcolor: 'primary.main' }}><Email /></Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                  primary={inv.name || inv.email}
                                  secondary={
                                    <React.Fragment>
                                      <Typography component="span" variant="body2" color="text.primary">{inv.email}</Typography>
                                      <br />
                                      <Typography component="span" variant="caption" color="text.secondary">
                                         {tr("Envoyé le")} {format(parseISO(inv.created_at), 'dd/MM/yyyy HH:mm', { locale: dateLocale })}
                                      </Typography>
                                      <Chip label={inv.status} size="small" color={inv.status === 'SENT' ? 'success' : 'default'} variant="outlined" sx={{ ml: 1, height: 20, fontSize: '0.65rem' }} />
                                    </React.Fragment>
                                  }
                                />
                              </ListItem>
                              <Divider variant="inset" component="li" />
                            </React.Fragment>
                          ))}
                        </List>
                      )}
                    </Paper>
                  </Grid>
                </Grid>
              </Paper>
            )}

        {/* TabPanel 5: Payments */}
        {tabValue === 5 && (
          <Stack spacing={3}>
          {/* Card Abonnement Stripe — masquee dans l'app native (regles des stores :
              l'abonnement se souscrit depuis le site web). */}
          {!isNativeApp() && (
          <Paper sx={{ borderRadius: 4, overflow: 'hidden' }}>
            <Box sx={{ p: 3, background: 'linear-gradient(135deg, #6366F1 0%, #00BCD4 100%)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
              <Box>
                <Typography variant="h6" fontWeight={800} color="white">{tr("Mon Abonnement Coach Pro")}</Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>{tr("19.90€ / mois · Accès à toutes les fonctionnalités · Sans engagement")}</Typography>
              </Box>
              {subscription ? (
                <Chip
                  label={
                    subscription.status === 'ACTIVE' ? '✅ Actif' :
                    subscription.status === 'PAST_DUE' ? '⚠️ Paiement en retard' :
                    subscription.status === 'CANCELLED' ? tr("❌ Annulé") : '⏳ Inactif'
                  }
                  sx={{
                    fontWeight: 700, fontSize: '0.9rem', px: 1,
                    bgcolor: subscription.status === 'ACTIVE' ? '#22C55E' :
                             subscription.status === 'PAST_DUE' ? '#F59E0B' : '#EF4444',
                    color: 'white'
                  }}
                />
              ) : null}
            </Box>
            <Box sx={{ p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
              <Box>
                {subscription?.next_billing_date && subscription?.status === 'ACTIVE' && (
                  <Typography variant="body2" color="text.secondary">
                     {tr("Prochain prélèvement :")} <b>{new Date(subscription.next_billing_date).toLocaleDateString(locale)}</b>
                  </Typography>
                )}
                {subscription?.status !== 'ACTIVE' && (
                  <Typography variant="body2" color="text.secondary">
                     {tr("Active ton abonnement pour accéder à toutes les fonctionnalités Coach.")} </Typography>
                )}
              </Box>
              <Stack direction="row" spacing={1}>
                {subscription?.status !== 'ACTIVE' ? (
                  <Button variant="contained" size="small" startIcon={<Payment />}
                    onClick={async () => {
                      try {
                        const res = await api.post('/payments/subscriptions/create_checkout_session/');
                        window.location.href = res.data.checkout_url;
                      } catch (e: any) {
                        toast.error(e.response?.data?.detail || 'Erreur lors de la création de la session de paiement.');
                      }
                    }}
                    sx={{ borderRadius: 2, fontWeight: 700 }}>
                     {tr("Activer mon abonnement · 19.90€/mois")} </Button>
                ) : (
                  <Button variant="outlined" size="small" color="error"
                    onClick={async () => {
                      const ok = await confirm({
                        title: 'Annuler votre abonnement Coach Pro ?',
                        description: "Vous conserverez l'accès jusqu'à la fin de la période déjà réglée.",
                        confirmLabel: "Annuler l'abonnement",
                      });
                      if (ok) {
                        try {
                          await api.post('/payments/subscriptions/cancel_subscription/');
                          fetchSubscription();
                        } catch (e: any) {
                          toast.error(e.response?.data?.detail || "Erreur lors de l'annulation.");
                        }
                      }
                    }}
                    sx={{ borderRadius: 2, fontWeight: 700 }}>
                     {tr("Annuler l'abonnement")} </Button>
                )}
              </Stack>
            </Box>
          </Paper>
          )}

          {/* Histogramme 3D mensuel des paiements - Coach (synchronisé avec onglet Séances) */}
          {(() => {
            const allMonths: Set<string> = new Set();
            const completedByMonth: Record<string, number> = {};
            const unpaidByMonth: Record<string, number> = {};
            bookings
              .filter((b: any) => b.status !== 'CANCELLED')
              .forEach((b: any) => {
                const d = new Date(b.start_time);
                const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
                allMonths.add(key);
                const price = Number(b.program_details?.price) || 0;
                if (b.latest_payment_status === 'COMPLETED') {
                  completedByMonth[key] = (completedByMonth[key] || 0) + price;
                } else {
                  unpaidByMonth[key] = (unpaidByMonth[key] || 0) + price;
                }
              });
            const chartData = Array.from(allMonths)
              .sort()
              .slice(-12)
              .map(key => ({
                month: new Date(key + '-01').toLocaleDateString(locale, { month: 'short', year: '2-digit' }),
                payé: completedByMonth[key] || 0,
                nonPayé: unpaidByMonth[key] || 0,
              }));
            if (chartData.length === 0) return null;
            const totalCompleted = bookings
              .filter((b: any) => b.latest_payment_status === 'COMPLETED')
              .reduce((s: number, b: any) => s + (Number(b.program_details?.price) || 0), 0);
            const totalUnpaid = bookings
              .filter((b: any) => b.status !== 'CANCELLED' && b.latest_payment_status !== 'COMPLETED')
              .reduce((s: number, b: any) => s + (Number(b.program_details?.price) || 0), 0);
            return (
              <Paper sx={{ borderRadius: 4, p: 3, mb: 3, background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
                  <Box>
                    <Typography variant="h6" fontWeight={800} sx={{ color: '#fff' }}>{tr("📊 Évolution des Revenus")}</Typography>
                    <Typography variant="caption" sx={{ color: '#9CA3AF' }}>{tr("12 derniers mois · Synchronisé avec onglet Séances")}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Chip label={`✅ Encaissé: ${totalCompleted.toFixed(2)} €`} sx={{ bgcolor: '#22C55E', color: '#fff', fontWeight: 700, fontSize: '0.75rem' }} />
                    <Chip label={`⏳ Non payé: ${totalUnpaid.toFixed(2)} €`} sx={{ bgcolor: '#F59E0B', color: '#fff', fontWeight: 700, fontSize: '0.75rem' }} />
                  </Box>
                </Box>
                <ResponsiveContainer width="100%" height={260}>
                  <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }} barCategoryGap="30%">
                    <defs>
                      <linearGradient id="coachBarGrad" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#22C55E" stopOpacity={1} />
                        <stop offset="100%" stopColor="#16A34A" stopOpacity={0.85} />
                      </linearGradient>
                      <linearGradient id="coachBarPending" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#F59E0B" stopOpacity={0.9} />
                        <stop offset="100%" stopColor="#D97706" stopOpacity={0.6} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="#ffffff10" vertical={false} />
                    <XAxis dataKey="month" tick={{ fill: '#9CA3AF', fontSize: 11 }} axisLine={false} tickLine={false} dy={8} />
                    <YAxis tick={{ fill: '#9CA3AF', fontSize: 11 }} axisLine={false} tickLine={false} tickFormatter={(v) => `${v}€`} width={55} />
                    <Tooltip
                      cursor={{ fill: '#ffffff08' }}
                      contentStyle={{ background: '#1e1e3a', border: '1px solid #22C55E30', borderRadius: 12, color: '#fff' }}
                      formatter={(value: any, name: any) => [`${Number(value).toFixed(2)} €`, name === 'payé' ? '✅ Encaissé' : '⏳ Non payé']}
                    />
                    <Legend formatter={(v: any) => <span style={{ color: '#9CA3AF', fontSize: 12 }}>{v === 'payé' ? tr("✅ Encaissé") : tr("⏳ Non payé")}</span>} />
                    <Bar dataKey="payé" fill="url(#coachBarGrad)" radius={[4, 4, 0, 0]} stackId="a" />
                    <Bar dataKey="nonPayé" fill="url(#coachBarPending)" radius={[4, 4, 0, 0]} stackId="a" />
                  </BarChart>
                </ResponsiveContainer>
              </Paper>
            );
          })()}

          <Paper sx={{ borderRadius: 4, overflow: 'hidden' }}>
            <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>{tr("Historique des Paiements")}</Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Chip
                  label={`✅ Encaissé: ${bookings.filter((b: any) => b.latest_payment_status === 'COMPLETED').reduce((s: number, b: any) => s + (Number(b.program_details?.price) || 0), 0).toFixed(2)} €`}
                  sx={{ bgcolor: '#22C55E', color: '#fff', fontWeight: 700, fontSize: '0.75rem' }}
                />
                <Chip
                  label={`⏳ Non payé: ${bookings.filter((b: any) => b.status !== 'CANCELLED' && b.latest_payment_status !== 'COMPLETED').reduce((s: number, b: any) => s + (Number(b.program_details?.price) || 0), 0).toFixed(2)} €`}
                  sx={{ bgcolor: '#F59E0B', color: '#fff', fontWeight: 700, fontSize: '0.75rem' }}
                />
              </Box>
            </Box>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
              {bookings.filter((b: any) => b.status !== 'CANCELLED').length === 0 ? (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                  <Typography color="text.secondary">{tr("Aucune séance enregistrée.")}</Typography>
                </Box>
              ) : (
                [...bookings]
                  .filter((b: any) => b.status !== 'CANCELLED')
                  .sort((a: any, b: any) => new Date(b.start_time).getTime() - new Date(a.start_time).getTime())
                  .map((bk: any) => (
                  <React.Fragment key={bk.id}>
                    <ListItem sx={{ p: isMobile ? 1.5 : 2, '&:hover': { bgcolor: 'action.hover' } }}>
                      <ListItemAvatar>
                        <Avatar sx={{ bgcolor: bk.latest_payment_status === 'COMPLETED' ? 'success.main' : 'warning.main', color: '#fff' }}>
                          <Euro />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primaryTypographyProps={{ component: 'div' }}
                        secondaryTypographyProps={{ component: 'div' }}
                        primary={
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="subtitle1" fontWeight="700">
                              {Number(bk.program_details?.price || 0).toFixed(2)} €
                            </Typography>
                            <PaymentBadge status={bk.latest_payment_status || 'UNPAID'} />
                          </Box>
                        }
                        secondary={
                          <Box sx={{ mt: 0.5 }}>
                            <Typography variant="body2" color="text.primary">
                               {tr("Sportif :")} <strong>{bk.sportif_details?.username || 'Utilisateur inconnu'}</strong>
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                               {tr("Séance :")} {format(parseISO(bk.start_time), 'PPP HH:mm', { locale: dateLocale })}
                              {bk.latest_transaction_id && ` • Réf: ${bk.latest_transaction_id}`}
                            </Typography>
                            {bk.program_details && (
                              <Typography variant="caption" display="block" color="primary">
                                 {tr("Programme :")} {bk.program_details.title}
                              </Typography>
                            )}
                          </Box>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </React.Fragment>
                ))
              )}
            </List>
          </Paper>
          </Stack>
        )}

        {/* TabPanel 6: Profile */}
        {tabValue === 6 && (
          <Paper sx={{ p: 4, borderRadius: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
               {tr("Informations du Profil")} </Typography>
            
            <Grid container spacing={3}>
              <Grid size={{ xs: 12 }} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
                  <Box sx={{ position: 'relative' }}>
                      <Avatar 
                          src={photoPreview || undefined} 
                          sx={{ width: 120, height: 120, mb: 2, border: '4px solid', borderColor: 'background.paper', boxShadow: 3 }}
                      >
                          {!photoPreview && <Person sx={{ fontSize: 60 }} />}
                      </Avatar>
                      <IconButton 
                          color="primary" 
                          aria-label="upload picture" 
                          component="label"
                          sx={{ position: 'absolute', bottom: 10, right: -10, bgcolor: 'background.paper', boxShadow: 1, '&:hover': { bgcolor: 'background.paper' } }}
                      >
                          <input hidden accept="image/*" type="file" onChange={handlePhotoChange} />
                          <CloudUpload />
                      </IconButton>
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                       {tr("Cliquez pour modifier votre photo de profil")} </Typography>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={tr("Sport enseigné")}
                  value={profileData.sport}
                  onChange={(e) => setProfileData({...profileData, sport: e.target.value})}
                  InputProps={{
                    startAdornment: <FitnessCenter sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Tarif horaire (€)"
                  type="number"
                  value={profileData.hourly_rate}
                  onChange={(e) => setProfileData({...profileData, hourly_rate: e.target.value})}
                  InputProps={{
                    startAdornment: <Euro sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
                  }}
                />
              </Grid>
              
              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label={tr("Présentation")}
                  multiline
                  rows={4}
                  value={profileData.bio}
                  onChange={(e) => setProfileData({...profileData, bio: e.target.value})}
                  placeholder={tr("Présentez-vous en quelques lignes...")}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Divider sx={{ my: 2 }}>
                  <Chip label={tr("Détails Professionnels")} />
                </Divider>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={tr("Adresse")}
                  value={profileData.address}
                  onChange={(e) => setProfileData({...profileData, address: e.target.value})}
                  InputProps={{
                    startAdornment: <LocationOn sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={tr("Ville de résidence")}
                  value={profileData.city}
                  onChange={(e) => setProfileData({...profileData, city: e.target.value})}
                  placeholder="Ex: Paris"
                  InputProps={{
                    startAdornment: <LocationOn sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={tr("Code postal")}
                  value={profileData.postal_code}
                  onChange={(e) => setProfileData({...profileData, postal_code: e.target.value})}
                  placeholder="Ex: 75001"
                />
              </Grid>

              <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={tr("Département")}
                  value={profileData.department}
                  onChange={(e) => setProfileData({...profileData, department: e.target.value})}
                  placeholder="Ex: Paris (75)"
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={tr("Ville d'entraînement")}
                  value={profileData.training_city}
                  onChange={(e) => setProfileData({...profileData, training_city: e.target.value})}
                  placeholder="Ex: Boulogne-Billancourt"
                  helperText={tr("Lieu principal où vous entraînez vos sportifs")}
                  InputProps={{
                    startAdornment: <LocationOn sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={profileData.is_itinerant === 'true'}
                      onChange={(e) => setProfileData({...profileData, is_itinerant: String(e.target.checked)})}
                      color="primary"
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="body2" fontWeight={600}>{tr("Coach itinérant")}</Typography>
                      <Typography variant="caption" color="text.secondary">{tr("Je me déplace chez le sportif ou au lieu choisi")}</Typography>
                    </Box>
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={tr("Moyens de paiement acceptés")}
                  value={profileData.payment_methods}
                  onChange={(e) => setProfileData({...profileData, payment_methods: e.target.value})}
                  placeholder={tr("Ex: Espèces, Virement, PayPal")}
                  InputProps={{
                    startAdornment: <Payment sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={tr("Langues parlées")}
                  value={profileData.languages}
                  onChange={(e) => setProfileData({...profileData, languages: e.target.value})}
                  placeholder={tr("Ex: Français, Anglais, Espagnol")}
                  InputProps={{
                    startAdornment: <Language sx={{ color: 'action.active', mr: 1, my: 0.5 }} />,
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={tr("Spécialités")}
                  value={profileData.specialties}
                  onChange={(e) => setProfileData({...profileData, specialties: e.target.value})}
                  placeholder="Ex: Perte de poids, Prise de masse"
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label={tr("Formations & Diplômes")}
                  multiline
                  rows={3}
                  value={profileData.education}
                  onChange={(e) => setProfileData({...profileData, education: e.target.value})}
                  placeholder="Listez vos certifications..."
                  InputProps={{
                    startAdornment: <School sx={{ color: 'action.active', mr: 1, mt: 1.5, alignSelf: 'flex-start' }} />,
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label={tr("Diplômes obtenus")}
                  multiline
                  rows={2}
                  value={profileData.diplomas}
                  onChange={(e) => setProfileData({...profileData, diplomas: e.target.value})}
                  placeholder="Licence STAPS, Brevet d'Etat, etc."
                  InputProps={{
                    startAdornment: <Assessment sx={{ color: 'action.active', mr: 1, mt: 1.5, alignSelf: 'flex-start' }} />,
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  label={tr("Expériences")}
                  multiline
                  rows={3}
                  value={profileData.experience}
                  onChange={(e) => setProfileData({...profileData, experience: e.target.value})}
                  placeholder={tr("Partagez vos expériences passées...")}
                  InputProps={{
                    startAdornment: <Work sx={{ color: 'action.active', mr: 1, mt: 1.5, alignSelf: 'flex-start' }} />,
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Divider sx={{ my: 2 }}>
                  <Chip label={tr("Réseaux Sociaux")} />
                </Divider>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Instagram"
                  value={profileData.social_instagram}
                  onChange={(e) => setProfileData({...profileData, social_instagram: e.target.value})}
                  placeholder="https://instagram.com/..."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="LinkedIn"
                  value={profileData.social_linkedin}
                  onChange={(e) => setProfileData({...profileData, social_linkedin: e.target.value})}
                  placeholder="https://linkedin.com/in/..."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Facebook"
                  value={profileData.social_facebook}
                  onChange={(e) => setProfileData({...profileData, social_facebook: e.target.value})}
                  placeholder="https://facebook.com/..."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Site Web"
                  value={profileData.social_website}
                  onChange={(e) => setProfileData({...profileData, social_website: e.target.value})}
                  placeholder="https://mon-site-coach.fr"
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="TikTok"
                  value={profileData.social_tiktok}
                  onChange={(e) => setProfileData({...profileData, social_tiktok: e.target.value})}
                  placeholder="https://tiktok.com/@..."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="X (Twitter)"
                  value={profileData.social_x}
                  onChange={(e) => setProfileData({...profileData, social_x: e.target.value})}
                  placeholder="https://x.com/..."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Snapchat"
                  value={profileData.social_snapchat}
                  onChange={(e) => setProfileData({...profileData, social_snapchat: e.target.value})}
                  placeholder="https://snapchat.com/add/..."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="YouTube"
                  value={profileData.social_youtube}
                  onChange={(e) => setProfileData({...profileData, social_youtube: e.target.value})}
                  placeholder="https://youtube.com/@..."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Pinterest"
                  value={profileData.social_pinterest}
                  onChange={(e) => setProfileData({...profileData, social_pinterest: e.target.value})}
                  placeholder="https://pinterest.com/..."
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={tr("WhatsApp (numéro)")}
                  value={profileData.social_whatsapp}
                  onChange={(e) => setProfileData({...profileData, social_whatsapp: e.target.value})}
                  placeholder="+33612345678"
                />
              </Grid>

              <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button 
                  variant="contained" 
                  size="large" 
                  startIcon={<Save />}
                  onClick={handleProfileUpdate}
                  sx={{ px: 4, py: 1.5, borderRadius: 2 }}
                >
                   {tr("Enregistrer les modifications")} </Button>
              </Grid>
            </Grid>
            <ChangePassword />
            <DeleteAccountButton />
          </Paper>
        )}

        {/* Modals */}
        {/* Modal Planning (disponibilité ou séance directe) */}
        <Dialog
          open={openModal}
          onClose={() => { setOpenModal(false); setEditingAvailId(null); }}
          fullScreen={isMobile}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 800, pb: 0 }}>
            {editingAvailId ? tr("Modifier la disponibilité") : tr("Planifier un créneau")}
          </DialogTitle>

          {/* Toggle mode — masqué en mode édition */}
          {!editingAvailId && (
            <Box sx={{ px: 3, pt: 2, pb: 0 }}>
              <ToggleButtonGroup
                value={planModalMode}
                exclusive
                onChange={(_, v) => v && setPlanModalMode(v)}
                fullWidth
                size="small"
              >
                <ToggleButton value="availability" sx={{ fontWeight: 700, fontSize: '0.78rem' }}>
                   {tr("🟢 Créneau disponible")} </ToggleButton>
                <ToggleButton value="session" sx={{ fontWeight: 700, fontSize: '0.78rem' }}>
                   {tr("📅 Séance directe")} </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          )}

          <DialogContent sx={{ pt: 2 }}>
            {/* ── Champs communs : horaires ── */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, mb: 1.5 }}>
              {/* Ligne Début */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <Typography variant="caption" fontWeight={700} color="primary.main" sx={{ minWidth: 36, fontSize: '0.7rem' }}>{tr("DÉB.")}</Typography>
                <TextField
                  type="date"
                  size="small"
                  sx={{ flex: 2 }}
                  value={newAvailability.start_time ? newAvailability.start_time.substring(0, 10) : ''}
                  onChange={(e) => {
                    const date = e.target.value;
                    const time = newAvailability.start_time ? newAvailability.start_time.substring(11, 16) : '09:00';
                    setNewAvailability({ ...newAvailability, start_time: `${date}T${time}` });
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  type="time"
                  size="small"
                  sx={{ flex: 1 }}
                  value={newAvailability.start_time ? newAvailability.start_time.substring(11, 16) : ''}
                  onChange={(e) => {
                    const time = e.target.value;
                    const date = newAvailability.start_time ? newAvailability.start_time.substring(0, 10) : new Date().toISOString().substring(0, 10);
                    setNewAvailability({ ...newAvailability, start_time: `${date}T${time}` });
                  }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                />
              </Box>
              {/* Séparateur */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <Box sx={{ minWidth: 36 }} />
                <Box sx={{ flex: 1, borderLeft: '2px solid', borderColor: 'divider', ml: 1, height: 12 }} />
              </Box>
              {/* Ligne Fin */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ minWidth: 36, fontSize: '0.7rem' }}>{tr("FIN")}</Typography>
                <TextField
                  type="date"
                  size="small"
                  sx={{ flex: 2 }}
                  value={newAvailability.end_time ? newAvailability.end_time.substring(0, 10) : ''}
                  onChange={(e) => {
                    const date = e.target.value;
                    const time = newAvailability.end_time ? newAvailability.end_time.substring(11, 16) : '10:00';
                    setNewAvailability({ ...newAvailability, end_time: `${date}T${time}` });
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  type="time"
                  size="small"
                  sx={{ flex: 1 }}
                  value={newAvailability.end_time ? newAvailability.end_time.substring(11, 16) : ''}
                  onChange={(e) => {
                    const time = e.target.value;
                    const date = newAvailability.end_time ? newAvailability.end_time.substring(0, 10) : new Date().toISOString().substring(0, 10);
                    setNewAvailability({ ...newAvailability, end_time: `${date}T${time}` });
                  }}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ step: 300 }}
                />
              </Box>
            </Box>

            {/* ── Mode Disponibilité ── */}
            {(planModalMode === 'availability' || editingAvailId) && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                <TextField
                  label="Nombre max de participants"
                  type="number"
                  fullWidth
                  size="small"
                  value={newAvailability.max_participants}
                  onChange={(e) => setNewAvailability({ ...newAvailability, max_participants: parseInt(e.target.value) || 1 })}
                  inputProps={{ min: 1 }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={newAvailability.is_recurring}
                      onChange={(e) => setNewAvailability({ ...newAvailability, is_recurring: e.target.checked })}
                    />
                  }
                  label={tr("Récurrence hebdomadaire")}
                />
              </Box>
            )}

            {/* ── Mode Séance directe ── */}
            {planModalMode === 'session' && !editingAvailId && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
                {/* Sélecteur sportif (multiple) */}
                <FormControl fullWidth size="small" required>
                  <InputLabel>{tr("Sportif(s) *")}</InputLabel>
                  <Select
                    multiple
                    value={planSessionData.sportif_ids}
                    label={tr("Sportif(s) *")}
                    onChange={(e) => setPlanSessionData({ ...planSessionData, sportif_ids: e.target.value as number[] })}
                    MenuProps={{ PaperProps: { style: { maxHeight: 240 } } }}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {(selected as number[]).map((id) => {
                          const s = sportifs.find(sp => sp.id === id);
                          return s ? (
                            <Chip key={id} size="small" label={s.username}
                              avatar={<Avatar sx={{ bgcolor: 'primary.main', fontSize: '0.6rem' }}>{s.username.charAt(0).toUpperCase()}</Avatar>}
                              sx={{ height: 22, fontSize: '0.72rem' }}
                            />
                          ) : null;
                        })}
                      </Box>
                    )}
                  >
                    {sportifs.map((s) => (
                      <MenuItem key={s.id} value={s.id}>
                        <Checkbox checked={planSessionData.sportif_ids.includes(s.id)} size="small" />
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 0.5 }}>
                          <Avatar sx={{ width: 24, height: 24, fontSize: '0.7rem', bgcolor: 'primary.main' }}>
                            {s.username.charAt(0).toUpperCase()}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" fontWeight={700}>{s.username}</Typography>
                            <Typography variant="caption" color="text.secondary">{s.email}</Typography>
                          </Box>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Sélecteur programme */}
                <FormControl fullWidth size="small">
                  <InputLabel>{tr("Programme (optionnel)")}</InputLabel>
                  <Select
                    value={planSessionData.program_id}
                    label={tr("Programme (optionnel)")}
                    onChange={(e) => setPlanSessionData({ ...planSessionData, program_id: e.target.value })}
                  >
                    <MenuItem value=""><em>{tr("Séance libre")}</em></MenuItem>
                    {programs.map((p) => (
                      <MenuItem key={p.id} value={p.id}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                          <Typography variant="body2" fontWeight={700}>{p.title}</Typography>
                          <Chip label={`${p.price} €`} size="small" color="primary" variant="outlined" sx={{ ml: 1, fontSize: '0.7rem' }} />
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {sportifs.length === 0 && (
                  <Alert severity="info" sx={{ fontSize: '0.78rem' }}>
                     {tr("Aucun sportif associé. Invitez d'abord un sportif depuis l'onglet \"Mes Sportifs\".")} </Alert>
                )}
                {programs.length === 0 && (
                  <Alert severity="info" sx={{ fontSize: '0.78rem' }}>
                     {tr("Aucun programme créé. La séance sera enregistrée comme séance libre.")} </Alert>
                )}
              </Box>
            )}
            {planModalError && (
              <Alert severity="error" sx={{ mt: 1.5, fontSize: '0.78rem' }}>{planModalError}</Alert>
            )}
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={() => { setOpenModal(false); setEditingAvailId(null); }}>{tr("Annuler")}</Button>
            {editingAvailId && (
              <Button color="error" onClick={async () => {
                const ok = await confirm({
                  title: 'Supprimer cette plage ?',
                  confirmLabel: 'Supprimer la plage',
                });
                if (!ok) return;
                await handleDeleteAvailability(editingAvailId);
                setOpenModal(false);
                setEditingAvailId(null);
              }}>
                 {tr("Supprimer")} </Button>
            )}
            <Button
              variant="contained"
              disabled={planModalMode === 'session' && !editingAvailId && planSessionData.sportif_ids.length === 0}
              onClick={planModalMode === 'session' && !editingAvailId ? handleCreateSession : handleSaveAvailability}
            >
              {editingAvailId ? tr("Enregistrer") : planModalMode === 'session' ? tr("Créer la séance") : tr("Créer le créneau")}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal Édition Booking */}
        <Dialog open={openEditBookingModal} onClose={() => { setOpenEditBookingModal(false); setEditingBooking(null); }} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ fontWeight: 700 }}>{tr("Modifier le créneau")}</DialogTitle>
          <DialogContent>
            {editingBooking && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32, fontSize: '0.85rem' }}>
                    {editingBooking.sportif_details?.username?.charAt(0).toUpperCase()}
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle2" fontWeight={700}>{editingBooking.sportif_details?.username}</Typography>
                    <Typography variant="caption" color="text.secondary">{editingBooking.program_details?.title || tr("Séance libre")}</Typography>
                  </Box>
                </Box>
                <TextField
                  label={tr("Début")}
                  type="datetime-local"
                  fullWidth
                  value={editBookingTimes.start_time}
                  onChange={(e) => setEditBookingTimes({ ...editBookingTimes, start_time: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  label={tr("Fin")}
                  type="datetime-local"
                  fullWidth
                  value={editBookingTimes.end_time}
                  onChange={(e) => setEditBookingTimes({ ...editBookingTimes, end_time: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setOpenEditBookingModal(false); setEditingBooking(null); }}>{tr("Annuler")}</Button>
            <Button onClick={handleSaveEditBooking} variant="contained" startIcon={<Save />}>{tr("Enregistrer")}</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openProgramModal} onClose={() => setOpenProgramModal(false)} fullWidth maxWidth="sm" fullScreen={isMobile}>
          <DialogTitle>{tr("Nouveau Programme")}</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label={tr("Titre")}
              fullWidth
              value={newProgram.title}
              onChange={(e) => setNewProgram({ ...newProgram, title: e.target.value })}
            />
            <TextField
              margin="dense"
              label={tr("Description")}
              fullWidth
              multiline
              minRows={3}
              value={newProgram.description}
              onChange={(e) => setNewProgram({ ...newProgram, description: e.target.value })}
            />
            <TextField
              margin="dense"
              label={tr("Prix")}
              type="number"
              fullWidth
              value={newProgram.price}
              onChange={(e) => setNewProgram({ ...newProgram, price: e.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenProgramModal(false)}>{tr("Annuler")}</Button>
            <Button variant="contained" onClick={handleCreateProgram} disabled={!newProgram.title.trim()}>
               {tr("Créer")} </Button>
          </DialogActions>
        </Dialog>

        {/* Sportif Details Modal */}
        <Dialog open={openSportifModal} onClose={() => setOpenSportifModal(false)} fullWidth maxWidth="md" fullScreen={isMobile}>
          {selectedSportif && (
            <>
              <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56 }}>{selectedSportif.username[0].toUpperCase()}</Avatar>
                  <Box>
                    <Typography variant="h5" fontWeight={700}>{selectedSportif.username}</Typography>
                    <Typography variant="body2" color="text.secondary">{selectedSportif.email}</Typography>
                  </Box>
                  <Box sx={{ flexGrow: 1 }} />
                  <Button 
                    variant="outlined" 
                    startIcon={<Chat />} 
                    onClick={() => navigate('/messages', { state: { recipient: selectedSportif, roleMode: 'COACH' } })}
                  >
                     {tr("Message")} </Button>
                </Box>
              </DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={3} sx={{ mb: 4 }}>
                  <Grid size={{ xs: 12, md: 4 }}>
                    <Paper sx={{ p: 2, textAlign: 'center', bgcolor: 'background.default' }}>
                      <Typography variant="h4" color="primary.main" fontWeight={700}>{selectedSportif.total_bookings}</Typography>
                      <Typography variant="body2" color="text.secondary">{tr("Total Séances")}</Typography>
                    </Paper>
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }}>
                    <Paper sx={{ p: 2, textAlign: 'center', bgcolor: 'background.default' }}>
                      <Typography variant="h4" color="success.main" fontWeight={700}>{selectedSportif.completed_bookings}</Typography>
                      <Typography variant="body2" color="text.secondary">{tr("Séances Terminées")}</Typography>
                    </Paper>
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }}>
                    <Paper sx={{ p: 2, textAlign: 'center', bgcolor: 'background.default' }}>
                      <Typography variant="h6" fontWeight={700}>
                        {selectedSportif.next_booking 
                          ? format(parseISO(selectedSportif.next_booking), 'd MMM, HH:mm', { locale: dateLocale })
                          : '-'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">{tr("Prochaine Séance")}</Typography>
                    </Paper>
                  </Grid>
                </Grid>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                    <Tabs value={sportifModalTab} onChange={(e, v) => setSportifModalTab(v)}>
                        <Tab label={tr("Historique des séances")} icon={<History />} iconPosition="start" />
                        <Tab label={tr("Performances")} icon={<Assessment />} iconPosition="start" />
                        <Tab label={tr("Graphiques")} icon={<ShowChart />} iconPosition="start" />
                    </Tabs>
                </Box>

                {sportifModalTab === 0 && (
                    <List>
                    {bookings
                        .filter(b => b.sportif_details.id === selectedSportif.id)
                        .sort((a, b) => new Date(b.start_time).getTime() - new Date(a.start_time).getTime())
                        .map((booking) => (
                        <ListItem key={booking.id} sx={{ bgcolor: 'background.default', mb: 1, borderRadius: 1 }}>
                            <ListItemText
                            primaryTypographyProps={{ component: 'div' }}
                            secondaryTypographyProps={{ component: 'div' }}
                            primary={
                                <Typography fontWeight={600}>
                                {format(parseISO(booking.start_time), 'PPP HH:mm', { locale: dateLocale })}
                                </Typography>
                            }
                            secondary={booking.program_details?.title || tr("Séance personnalisée")}
                            />
                            <StatusBadge status={booking.status} />
                        </ListItem>
                        ))}
                        {bookings.filter(b => b.sportif_details.id === selectedSportif.id).length === 0 && (
                        <Typography color="text.secondary" align="center" sx={{ py: 2 }}>{tr("Aucun historique disponible")}</Typography>
                        )}
                    </List>
                )}

                {sportifModalTab === 1 && (
                    <Box>
                        {!showPerformanceForm ? (
                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                                    <Button variant="contained" startIcon={<Add />} onClick={() => setShowPerformanceForm(true)}>
                                         {tr("Nouvelle Évaluation")} </Button>
                                </Box>
                                <List>
                                    {performances.length === 0 ? (
                                        <Typography color="text.secondary" align="center" sx={{ py: 2 }}>{tr("Aucune évaluation enregistrée.")}</Typography>
                                    ) : (
                                        performances.map((perf) => (
                                            <Paper key={perf.id} variant="outlined" sx={{ mb: 2, p: 2, borderRadius: 2 }}>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                    <Typography variant="subtitle1" fontWeight={700}>
                                                        {format(parseISO(perf.date), 'PPP', { locale: dateLocale })}
                                                    </Typography>
                                                    <Chip label={`${(perf.global_score / 10).toFixed(1).replace('.', ',')}/10`} color="primary" size="small" />
                                                </Box>
                                                <Grid container spacing={1} sx={{ mb: 2 }}>
                                                    {[
                                                        [tr("Physique"), perf.physical_condition, 'success.main'],
                                                        [tr("Technique"), perf.technical_mastery, 'warning.main'],
                                                        [tr("Mental"), perf.mental_strength, 'error.main'],
                                                        ['Motivation', perf.motivation, 'primary.main'],
                                                        [tr("Tonicité"), perf.tonicite, '#06B6D4'],
                                                        ['Tactique', perf.tactique, '#8B5CF6'],
                                                        ['Volontaire', perf.volontaire, '#F59E0B'],
                                                        ['En forme', perf.fatigue_level, 'text.secondary'],
                                                        [tr("Gestion Émotion"), perf.stress_level, 'text.secondary'],
                                                        ['Sommeil', perf.sleep_quality, 'text.secondary'],
                                                    ].map(([label, val, color]) => (
                                                        <Grid size={{ xs: 4, sm: 3 }} key={String(label)}>
                                                            <Box sx={{ textAlign: 'center', p: 0.5, bgcolor: 'background.default', borderRadius: 1 }}>
                                                                <Typography variant="caption" display="block" color="text.secondary">{tr(label)}</Typography>
                                                                <Typography variant="body2" fontWeight={700} color={color as any}>{val !== null && val !== undefined ? val : '-'}</Typography>
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                                {perf.notes && (
                                                    <Typography variant="body2" color="text.secondary" sx={{ bgcolor: 'action.hover', p: 1, borderRadius: 1 }}>
                                                        {perf.notes}
                                                    </Typography>
                                                )}
                                            </Paper>
                                        ))
                                    )}
                                </List>
                            </>
                        ) : (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>{tr("Nouvelle Évaluation")}</Typography>
                                <TextField label={tr("Date")} type="date" size="small" value={newPerformance.date} onChange={(e) => setNewPerformance({...newPerformance, date: e.target.value})} InputLabelProps={{ shrink: true }} sx={{ mb: 1 }} />
                                {([
                                    { key: 'endurance',          label: 'Endurance',            color: '#4caf50' },
                                    { key: 'technical_mastery',  label: tr("Maîtrise Technique"),   color: '#2196f3' },
                                    { key: 'mental_strength',    label: 'Force Mentale',         color: '#2196f3' },
                                    { key: 'motivation',         label: 'Motivation',            color: '#9c27b0' },
                                    { key: 'explosivite',        label: tr("Explosivité"),           color: '#06B6D4' },
                                    { key: 'tactique',           label: 'Tactique',              color: '#8B5CF6' },
                                    { key: 'volontaire',         label: 'Volontaire',            color: '#F59E0B' },
                                    { key: 'fatigue_level',      label: 'En forme',              color: '#795548' },
                                    { key: 'stress_level',       label: tr("Gestion Émotion"),       color: '#f44336' },
                                    { key: 'coordination',       label: 'Coordination',          color: '#0288d1' },
                                ] as { key: keyof typeof newPerformance; label: string; color: string }[]).map(({ key, label, color }) => (
                                    <RatingSquares
                                        key={key}
                                        label={tr(label)}
                                        color={color}
                                        value={(newPerformance as any)[key]}
                                        onChange={(v) => {
                                            const updated = { ...newPerformance, [key]: v };
                                            const keys: (keyof typeof newPerformance)[] = ['endurance','technical_mastery','mental_strength','motivation','explosivite','tactique','volontaire','fatigue_level','stress_level','coordination'];
                                            const avg = keys.reduce((s, k) => s + ((updated as any)[k] || 0), 0) / keys.length;
                                            updated.global_score = Math.round(avg * 10);
                                            setNewPerformance(updated);
                                        }}
                                    />
                                ))}
                                <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'action.hover', mb: 1 }}>
                                    <Typography variant="body2" fontWeight={700}>{tr("Score Global (moyenne automatique) :")} {(newPerformance.global_score / 10).toFixed(1).replace('.', ',')}/10</Typography>
                                </Box>
                                <TextField label="Notes & Observations" multiline rows={3} fullWidth value={newPerformance.notes} onChange={(e) => setNewPerformance({...newPerformance, notes: e.target.value})} />
                                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mt: 1 }}>
                                    <Button onClick={() => setShowPerformanceForm(false)}>{tr("Annuler")}</Button>
                                    <Button variant="contained" onClick={handleCreatePerformance} startIcon={<Save />}>{tr("Enregistrer")}</Button>
                                </Box>
                            </Box>
                        )}
                    </Box>
                )}

                {sportifModalTab === 2 && (
                    <Box sx={{ mt: 2, p: 1 }}>
                        {performances.length === 0 ? (
                            <Typography color="text.secondary" align="center" sx={{ py: 4 }}>
                                 {tr("Aucune donnée de performance disponible.")} </Typography>
                        ) : (
                            <Grid container spacing={3}>
                                {/* Radar Chart for Latest Performance */}
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <PerformanceProfile data={radarData} date={latestPerformance?.date} />
                                </Grid>

                                {/* Evolution Chart - Performance */}
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <PerformanceEvolution data={chartData} series={["endurance","technical_mastery","mental_strength","global_score"]} wellbeing={false} />
                                </Grid>

                                {/* Evolution Chart - Wellbeing */}
                                <Grid size={{ xs: 12 }}>
                                    <PerformanceEvolution data={chartData} series={["motivation","coordination","stress_level","fatigue_level"]} wellbeing={true} />
                                </Grid>

                            </Grid>
                        )}
                    </Box>
                )}

              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenSportifModal(false)}>{tr("Fermer")}</Button>
              </DialogActions>
            </>
          )}
        </Dialog>

        {/* Invitations History Modal */}
        <Dialog open={openInvitationsModal} onClose={() => setOpenInvitationsModal(false)} maxWidth="sm" fullWidth>
            <DialogTitle>{tr("Historique des invitations")}</DialogTitle>
            <DialogContent dividers>
                {invitations.length === 0 ? (
                    <Box sx={{ p: 3, textAlign: 'center' }}>
                        <Typography color="text.secondary">{tr("Aucune invitation envoyée.")}</Typography>
                    </Box>
                ) : (
                    <List>
                        {invitations.map((invitation) => (
                            <React.Fragment key={invitation.id}>
                                <ListItem alignItems="flex-start">
                                    <ListItemAvatar>
                                        <Avatar sx={{ bgcolor: invitation.mode === 'email' ? 'primary.main' : 'secondary.main' }}>
                                            {invitation.mode === 'email' ? <Email /> : <Chat />}
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={invitation.name || invitation.email}
                                        secondary={
                                            <React.Fragment>
                                                <Typography component="span" variant="body2" color="text.primary">
                                                    {invitation.email}
                                                </Typography>
                                                <br />
                                                <Typography component="span" variant="caption" color="text.secondary">
                                                     {tr("Envoyé le")} {format(parseISO(invitation.created_at), 'dd/MM/yyyy HH:mm', { locale: dateLocale })}
                                                </Typography>
                                                <Chip 
                                                    label={invitation.status} 
                                                    size="small" 
                                                    color={invitation.status === 'SENT' ? 'success' : 'default'} 
                                                    variant="outlined"
                                                    sx={{ ml: 1, height: 20, fontSize: '0.65rem' }}
                                                />
                                            </React.Fragment>
                                        }
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </React.Fragment>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenInvitationsModal(false)}>{tr("Fermer")}</Button>
            </DialogActions>
        </Dialog>

        {/* Invite Modal */}
        <Dialog open={openInviteModal} onClose={() => setOpenInviteModal(false)} maxWidth="sm" fullWidth>
            <DialogTitle>{tr("Inviter un nouveau sportif")}</DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                     {tr("Envoyez une invitation pour permettre à votre sportif de rejoindre G1Sport.")} </Typography>
                
                <Stack spacing={2}>
                    <TextField
                        label={tr("Nom complet (Optionnel)")}
                        fullWidth
                        value={inviteData.name}
                        onChange={(e) => setInviteData({ ...inviteData, name: e.target.value })}
                    />
                    
                    <TextField
                          label="Adresse Email"
                          fullWidth
                          required
                          type="email"
                          value={inviteData.email}
                          onChange={(e) => setInviteData({ ...inviteData, email: e.target.value })}
                      />

                    <TextField
                        label={tr("Message personnalisé (Optionnel)")}
                        fullWidth
                        multiline
                        rows={3}
                        value={inviteData.custom_message}
                        onChange={(e) => setInviteData({ ...inviteData, custom_message: e.target.value })}
                        placeholder={tr("Ajoutez un petit mot personnel...")}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenInviteModal(false)}>{tr("Annuler")}</Button>
                <Button 
                    onClick={handleSendInvite} 
                    variant="contained" 
                    disabled={!inviteData.email}
                    startIcon={<Email />}
                >
                     {tr("Envoyer")} </Button>
            </DialogActions>
        </Dialog>

        <Snackbar 
          open={!!profileMessage.text} 
          autoHideDuration={6000} 
          onClose={() => setProfileMessage({ type: '', text: '' })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert 
            onClose={() => setProfileMessage({ type: '', text: '' })} 
            severity={profileMessage.type as 'success' | 'error'} 
            sx={{ width: '100%' }}
          >
            {tr(profileMessage.text)}
          </Alert>
        </Snackbar>

        <Dialog open={openRatingModal} onClose={() => setOpenRatingModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>{tr("Noter la séance")}</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            {([
              { key: 'endurance',          label: 'Endurance',            color: '#4caf50' },
              { key: 'technical_mastery',  label: tr("Maîtrise Technique"),   color: '#2196f3' },
              { key: 'mental_strength',    label: 'Force Mentale',         color: '#2196f3' },
              { key: 'motivation',         label: 'Motivation',            color: '#9c27b0' },
              { key: 'explosivite',        label: tr("Explosivité"),           color: '#06B6D4' },
              { key: 'tactique',           label: 'Tactique',              color: '#8B5CF6' },
              { key: 'volontaire',         label: 'Volontaire',            color: '#F59E0B' },
              { key: 'fatigue_level',      label: 'En forme',              color: '#795548' },
              { key: 'stress_level',       label: tr("Gestion Émotion"),       color: '#f44336' },
              { key: 'coordination',       label: 'Coordination',          color: '#0288d1' },
            ] as { key: keyof typeof ratingData; label: string; color: string }[]).map(({ key, label, color }) => (
              <RatingSquares
                key={key}
                label={tr(label)}
                color={color}
                value={(ratingData as any)[key]}
                onChange={(v) => {
                  const updated = { ...ratingData, [key]: v };
                  const scoreKeys: (keyof typeof ratingData)[] = ['endurance','technical_mastery','mental_strength','motivation','explosivite','tactique','volontaire','fatigue_level','stress_level','coordination'];
                  const avg = scoreKeys.reduce((s, k) => s + ((updated as any)[k] || 0), 0) / scoreKeys.length;
                  updated.global_score = Math.round(avg * 10);
                  setRatingData(updated);
                }}
              />
            ))}
            <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'action.hover', mb: 2 }}>
              <Typography gutterBottom sx={{ fontWeight: 700 }}>{tr("Score Global (moyenne automatique) :")} {(ratingData.global_score / 10).toFixed(1).replace('.', ',')}/10</Typography>
            </Box>
            <TextField
              label="Notes / Commentaires"
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={ratingData.notes}
              onChange={(e) => setRatingData({...ratingData, notes: e.target.value})}
              placeholder={tr("Détails sur la performance, points à améliorer...")}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRatingModal(false)}>{tr("Annuler")}</Button>
          <Button onClick={submitRatingAndComplete} variant="contained" color="success">
             {tr("Valider et Terminer")} </Button>
        </DialogActions>
      </Dialog>

      {/* ── Modale détail journée calendrier ── */}
      <Dialog
        open={calDayModal.open}
        onClose={() => setCalDayModal({ open: false, date: '', events: [] })}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, bgcolor: '#1A1A2E', color: '#fff' } }}
      >
        <DialogTitle sx={{ pb: 1, fontWeight: 800, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          📅 {calDayModal.date ? format(parseISO(calDayModal.date), 'EEEE d MMMM yyyy', { locale: dateLocale }) : ''}
          <Typography variant="caption" sx={{ ml: 1, color: 'text.secondary' }}>
            ({calDayModal.events.length}  {tr("événement")}{calDayModal.events.length !== 1 ? 's' : ''})
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          {calDayModal.events.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography color="text.secondary">{tr("Aucun créneau ni séance ce jour.")}</Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {[...calDayModal.events]
                .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime())
                .map((ev, idx) => {
                  const isAvail = ev.id?.startsWith('av-');
                  const bk = ev.extendedProps?.booking;
                  const av = ev.extendedProps?.availability;
                  const color = ev.backgroundColor || '#3B82F6';
                  const startTime = ev.start ? format(parseISO(ev.start), 'HH:mm') : '';
                  const endTime = ev.end ? format(parseISO(ev.end), 'HH:mm') : '';
                  return (
                    <Paper key={idx} variant="outlined" sx={{
                      p: 1.5, borderRadius: 2,
                      borderLeft: `4px solid ${color}`,
                      bgcolor: 'rgba(255,255,255,0.04)',
                      borderColor: `${color}55`,
                    }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
                        <Box sx={{ minWidth: 0 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
                            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
                            <Typography variant="body2" fontWeight={800} sx={{ color: '#fff' }}>
                              {isAvail ? tr("🟢 Créneau disponible") : `👤 ${ev.title}`}
                            </Typography>
                          </Box>
                          <Typography variant="caption" sx={{ color: '#aaa', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            🕐 {startTime} → {endTime}
                          </Typography>
                          {bk && (
                            <Box sx={{ mt: 0.75, display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                              {bk.program_details?.title && (
                                <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                                  🏋️ {bk.program_details.title}
                                </Typography>
                              )}
                              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.25 }}>
                                <StatusBadge status={bk.status} isCoachCreated={bk.is_coach_created} />
                              </Box>
                            </Box>
                          )}
                          {av && av.max_participants > 1 && (
                            <Typography variant="caption" sx={{ color: '#94a3b8', mt: 0.5, display: 'block' }}>
                               {tr("👥 Max")} {av.max_participants}  {tr("participants")} </Typography>
                          )}
                        </Box>
                        {bk && (
                          <IconButton aria-label={tr("Ouvrir la conversation")}
                            size="small"
                            onClick={() => {
                              navigate('/messages', { state: { recipient: bk.sportif_details, roleMode: 'COACH' } });
                              setCalDayModal({ open: false, date: '', events: [] });
                            }}
                            sx={{ color: '#60a5fa', p: 0.5, flexShrink: 0 }}
                          >
                            <Chat sx={{ fontSize: 16 }} />
                          </IconButton>
                        )}
                      </Box>
                    </Paper>
                  );
                })}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ borderTop: '1px solid rgba(255,255,255,0.08)', px: 2, py: 1.5 }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              if (accessLocked) {
                setCalDayModal({ open: false, date: '', events: [] });
                setSubscriptionRequiredOpen(true);
                return;
              }
              const d = calDayModal.date;
              const now = new Date();
              const hhmm = `${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
              const end = new Date(now.getTime() + 60 * 60 * 1000);
              const endHhmm = `${String(end.getHours()).padStart(2,'0')}:${String(end.getMinutes()).padStart(2,'0')}`;
              setNewAvailability({ start_time: `${d}T${hhmm}`, end_time: `${d}T${endHhmm}`, is_recurring: false, max_participants: 1 });
              setPlanSessionData({ sportif_ids: [], program_id: '', note: '' });
              setPlanModalError('');
              setEditingAvailId(null);
              setPlanModalMode('session');
              setCalDayModal({ open: false, date: '', events: [] });
              setOpenModal(true);
            }}
            sx={{ fontWeight: 700, borderRadius: 2 }}
          >
             {tr("+ Planifier une séance ce jour")} </Button>
          <Button onClick={() => setCalDayModal({ open: false, date: '', events: [] })} sx={{ color: '#aaa' }}>
             {tr("Fermer")} </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Confirmation Action ── */}
      <Dialog open={!!confirmAction} onClose={() => setConfirmAction(null)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontWeight: 800, display: 'flex', alignItems: 'center', gap: 1, borderBottom: 1, borderColor: 'divider', pb: 1.5 }}>
          {confirmAction?.type === 'pay' && <><Euro sx={{ color: '#16A34A' }} />  {tr("Confirmer le paiement")}</>}
          {confirmAction?.type === 'cancel' && <><Cancel sx={{ color: 'error.main' }} />  {tr("Annuler la séance")}</>}
          {confirmAction?.type === 'complete' && <><CheckCircle sx={{ color: 'warning.main' }} />  {tr("Terminer la séance")}</>}
          {confirmAction?.type === 'deleteAvail' && <><Delete sx={{ color: 'error.main' }} />  {tr("Supprimer le créneau")}</>}
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {confirmAction?.type === 'pay' && tr("Voulez-vous marquer cette séance comme payée ? Cette action enregistrera le paiement du sportif.")}
            {confirmAction?.type === 'cancel' && tr("Voulez-vous annuler cette séance ? Le sportif sera notifié de l'annulation.")}
            {confirmAction?.type === 'complete' && tr("Voulez-vous marquer cette séance comme terminée ? Vous pourrez ensuite noter la performance du sportif.")}
            {confirmAction?.type === 'deleteAvail' && tr("Voulez-vous supprimer ce créneau de disponibilité ? Cette action est irréversible.")}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button onClick={() => setConfirmAction(null)} color="inherit" sx={{ borderRadius: 2 }}>{tr("Annuler")}</Button>
          <Button
            variant="contained"
            color={confirmAction?.type === 'pay' ? 'success' : confirmAction?.type === 'complete' ? 'warning' : 'error'}
            sx={{ borderRadius: 2 }}
            onClick={async () => {
              if (!confirmAction) return;
              const { type, bookingId, availId } = confirmAction;
              setConfirmAction(null);
              if (type === 'pay' && bookingId) await handleMarkPaid(bookingId);
              else if (type === 'cancel' && bookingId) await handleBookingAction(bookingId, 'cancel');
              else if (type === 'complete' && bookingId) await handleBookingAction(bookingId, 'complete');
              else if (type === 'deleteAvail' && availId) await handleDeleteAvailability(availId);
            }}
          >
            {confirmAction?.type === 'pay' && tr("Confirmer le paiement")}
            {confirmAction?.type === 'cancel' && tr("Annuler la séance")}
            {confirmAction?.type === 'complete' && tr("Terminer la séance")}
            {confirmAction?.type === 'deleteAvail' && tr("Supprimer")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Abonnement requis — masque dans l'app native (regles des stores). */}
      {!isNativeApp() && (
      <Dialog open={subscriptionRequiredOpen} onClose={() => setSubscriptionRequiredOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 800, color: 'warning.main', display: 'flex', alignItems: 'center', gap: 1 }}>
           {tr("⏰ Période d'essai terminée")} </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
             {tr("Votre période d'essai de")} <strong>{tr("180 jours")}</strong>  {tr("est arrivée à terme.")} </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
             {tr("Pour continuer à créer des séances et accéder à toutes les fonctionnalités Coach Pro, activez votre abonnement à")} <strong>{tr("19.90€/mois")}</strong>.
          </Typography>
          <Box sx={{ bgcolor: 'primary.main', borderRadius: 2, p: 2, color: 'white', mb: 1 }}>
            <Typography variant="body2" fontWeight={700}>{tr("✅ Accès illimité aux séances")}</Typography>
            <Typography variant="body2" fontWeight={700}>{tr("✅ Gestion de vos sportifs")}</Typography>
            <Typography variant="body2" fontWeight={700}>{tr("✅ Suivi des performances")}</Typography>
            <Typography variant="body2" fontWeight={700}>{tr("✅ Support prioritaire")}</Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, flexDirection: 'column', gap: 1 }}>
          <Button
            variant="contained" fullWidth size="large"
            startIcon={<Payment />}
            onClick={async () => {
              try {
                const res = await api.post('/payments/subscriptions/create_checkout_session/');
                setSubscriptionRequiredOpen(false);
                window.location.href = res.data.checkout_url;
              } catch (e: any) {
                toast.error(e.response?.data?.detail || 'Erreur lors de la création de la session de paiement.');
              }
            }}
            sx={{ borderRadius: 2, fontWeight: 800, py: 1.5 }}
          >
             {tr("Activer mon abonnement · 19.90€/mois")} </Button>
          <Button variant="text" fullWidth onClick={() => setSubscriptionRequiredOpen(false)} sx={{ borderRadius: 2 }}>
             {tr("Plus tard")} </Button>
        </DialogActions>
      </Dialog>
      )}

      </Container>
      </Box>
    </Box>
  );
};

export default CoachDashboard;
